/// <reference path="../HTMLHelpers.js"/>
/// <reference path="../Constants.js" />
/// <reference path="ChartSetupUI.js" />


window.DataGroupSelections = function () {
    var selAnswers = [];
    function storeSelectedAnswers(answerListBox) {
        selAnswers = [];
        $("option:selected", answerListBox).each(function () {
            selAnswers.push($(this).text());
        });
    }

    function setBitFlags(checkboxClass, bitmask) {
        $(checkboxClass + "[type='checkbox']").each(function () {
            var val = parseInt($(this).val() || 0, 10);
            $(this).attr("checked", (val & bitmask) == val);
        });
    }

    // hide options rather than rebuild
    // some browsers (ie included) do not support hiding individual options, use wrap instead
    function hideShowOptions(selectElem, values) {
        HTMLHelpers.optionToComment($(selectElem).find('option'));
        for (var i = 0; i < values.length; i++) {
            HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($(selectElem), 'option[value="' + values[i] + '"]'));
        }
    }

    function hideOption(selectElem, value) {
        HTMLHelpers.optionToComment($(selectElem).find('option[value="' + value + '"]'));
    }

    function showOption(selectElem, value) {
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($(selectElem), 'option[value="' + value + '"]'));        
    }

    function unwrapAll() {
        // unwrap options previously wrapped in chartLab
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#lbQB")));
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlCalculationType")));
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlTimePeriod")));
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlMovingAverage")));
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlInterval")));
        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($("#ddlSeriesOptions")));    
    }

    function mapSortKeys(arr) {
        return $.map(arr, function (e) {
            return e.sortValue;
        }).join('##');
    }

    return {
        SetSelectedQuestions: function (questionArray) {
			HTMLHelpers.setSelectedValues('#questionBox', questionArray);
			ChartSetupUI.limitLoopQnSelections();
            ChartSetupUI.disableForSelectedQuestions();
            ChartSetupUI.showHideBaseInLoopedQnSettingsBox();
            ChartSetupUI.showHideRebaseSettingsBox();
        },
        SetSelectedAnswers: function (answerArray) {
            HTMLHelpers.setSelectedValues('#answerbox', answerArray);
            if ($("#answerbox option:selected").length < 1)
                $("#answerbox").val("all");
            storeSelectedAnswers($("#answerbox"));
        },
        StoreSelectedAnswers: function (answerListBox) {
            storeSelectedAnswers(answerListBox);
        },
        RestoreSelectedAnswers: function (answerListBox) {
            if (selAnswers) {
                $("option", answerListBox).removeAttr('selected');
                $("option", answerListBox).each(function () {
                    if ($.inArray($(this).text(), selAnswers) > -1)
                        $(this).attr("selected", true);
                });
            }

            if ($("option:selected", answerListBox).length < 1)
                $("#answerbox").val("all");
        },
        SetSelectedQuestionBlocks: function (qbArray) {
            DataGroupSelections.ShowHideFilterPanel(qbArray, "#qbFilterPanel", "#chkQB");
            HTMLHelpers.setSelectedValues('#lbQB', qbArray);
        },
        SetSelectedGridQuestions: function (gqArray) {
            DataGroupSelections.ShowHideFilterPanel(gqArray, "#gqFilterPanel", "#chkGQ");
            HTMLHelpers.setSelectedValues('#lbGQ', gqArray);
        },
        SetSelectedVariableSubsets: function (vsArray) {
            DataGroupSelections.ShowHideFilterPanel(vsArray, "#vsFilterPanel", "#chkVS");
            HTMLHelpers.setSelectedValues('#lbVS', vsArray);
        },
        SetCorrelationSettings: function (correlations) {
            HTMLHelpers.setSelectedValues("#correlationQuestionBox", correlations.questionId);
            HTMLHelpers.setSelectedValues("#ddlCorrelationOption", correlations.correlationOption);
        },
        ClearFilterSelections: function () {
            /* clear all filter selections*/
			HTMLHelpers.setSelectedValues($("#filterBox div select, #loopIteratorFilters div select"), 0);
			$("#filterBox, #loopIteratorFilters").find('#chkCompare').each(function () {
                $(this).attr("checked", false).attr('disabled', 'disabled');
            });
        },
        SetSelectedFilters: function (filterArray) {
            this.ClearFilterSelections();

            $(filterArray).each(function () {
                if (!this.filterId) return;
				var filterbox = $("#filterBox, #loopIteratorFilters").find("div #hidFilterId[value='" + this.filterId + "']").parent();
                filterbox.find('#chkCompare').attr("checked", this.compare);

                if (this.allAnswers)
                    HTMLHelpers.setSelectedValues(filterbox.find('select'), "all");
                else {
                    var answerIds = $.map(this.answers, function (e) { return isNaN(e.answerId) ? e : e.answerId });
                    HTMLHelpers.setSelectedValues(filterbox.find('select'), answerIds);
                }

                if (filterbox.find('select option[value="0"]:selected').length == 0)
                    filterbox.find('#chkCompare').removeAttr('disabled');

                filterbox.find('#chkUseDynamicWeighting').attr("checked", this.useDynamicWeighting);

                if (filterbox.find('select option[value="0"]:selected').length == 0 && this.compare && this.isConnectedToWeights)
                    filterbox.find('#chkUseDynamicWeighting').removeAttr('disabled');

                ChartSetupUI.addFilterToGrouping(filterbox.find('#chkCompare'));
            });
            ChartSetupDataBinding.UpdateGroupings();
        },
        SetSelectedTimeSettings: function (timeSelections, optionalFilterSettings) {
            HTMLHelpers.setSelectedValues('#ddlTimePeriod', timeSelections.timePeriod);
            ChartSetupUI.showHideDateSelections();

            HTMLHelpers.setSelectedValues('#ddlInterval', timeSelections.timeInterval);
            $('#txtTimePeriod').val('');
            $('#txtTimePeriod').val(timeSelections.timePeriodSpanAmount);
            HTMLHelpers.setSelectedValues('#ddlTimePeriodSpan', timeSelections.timePeriodSpan);
            HTMLHelpers.setSelectedValues('#ddlMovingAverage', timeSelections.movingAverage);
            $("#chbShowMovingAverageSpan").attr("checked", timeSelections.showMovingAverageSpan);
            $("#chbShowPreviousIntervals").attr("checked", timeSelections.showPreviousIntervals);
            $("#ddlMovingAverage").change();
            HTMLHelpers.setSelectedValues('#ddlDateVar', timeSelections.dateVariableId);

            $('#txtStartDate').datepicker('setDate', timeSelections.startDate);
            $('#txtStopDate').datepicker('setDate', timeSelections.stopDate);

            $('#chbIncludeTheSamePeriodOfPreviousYears').attr("checked", timeSelections.includeTheSamePeriodOfPreviousYears);
            $('#chbIncludePreviousPeriods').attr("checked", timeSelections.includePreviousPeriods);

            $('#txtNumberOfPreviousYears').val(timeSelections.numberOfPreviousYears);
            $('#txtNumberOfPreviousPeriods').val(timeSelections.numberOfPreviousPeriods);

            var selectedTimePeriod = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.TimePeriod);
            var interval = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.Interval);
            var movingAverage = GeneralSettings.getSettingByType(GeneralSettings.getSelectedSettings(), Storyboard.Constants.SettingTypes.MovingAverage);

            var optionalFilterTimePeriodEnabled = (optionalFilterSettings && optionalFilterSettings.find(e => e.optionalSettingType === 4) !== undefined) ? optionalFilterSettings.find(e => e.optionalSettingType === 4).isApply : true;
            var optionalFilterIntervalEnabled = (optionalFilterSettings && optionalFilterSettings.find(e => e.optionalSettingType === 5) !== undefined) ? optionalFilterSettings.find(e => e.optionalSettingType === 5).isApply : true;
            var optionalFilterMovingAverageEnabled = (optionalFilterSettings && optionalFilterSettings.find(e => e.optionalSettingType === 6) !== undefined) ? optionalFilterSettings.find(e => e.optionalSettingType === 6).isApply : true;

            if ((selectedTimePeriod && optionalFilterTimePeriodEnabled) || (interval && optionalFilterIntervalEnabled) || (movingAverage && optionalFilterMovingAverageEnabled))
                $('#lblTimePeriodInfo').show();
            else
                $('#lblTimePeriodInfo').hide();

            ChartSetupUI.setTimePeriodInfoMessage(selectedTimePeriod && optionalFilterTimePeriodEnabled, interval && optionalFilterIntervalEnabled, movingAverage && optionalFilterMovingAverageEnabled);

            ChartSetupUI.showTimeSettingsComparationOptions(selectedTimePeriod && optionalFilterTimePeriodEnabled);
        },
		SetWeightSettings: function (useWeight, weightVariableId) {
            $("#chkUseWeight").attr("checked", useWeight);
            HTMLHelpers.setSelectedValues('#ddlWeight', weightVariableId);
        },
        SetSelectedCalculationType: function (calculationType, numericPercentileValue, isMainDg, optionalChartSettings) {
            var groupTypes = Storyboard.Constants.GroupTypes;
            var consts = Storyboard.Constants;

            if (calculationType == consts.CalculationTypes.CORRELATION_ANALYSIS)
                ChartSetupDataCom.FilterCorrelationQuestions();

            //currently all flavors of charts requires a question grouping
            var questionGrouping = groupTypes.getGroupItem(groupTypes.QUESTION_VAL, consts.Axis.axis, 0, '');
            ChartSetupDataBinding.EnsureGroupingExists(questionGrouping);

            /* add answer grouping where applicable */
            if (consts.CalculationTypes.isAnswerBased(calculationType)) {
                var answerGrouping = groupTypes.getGroupItem(groupTypes.ANSWER_VAL, consts.Axis.legend, 0, '');
                ChartSetupDataBinding.EnsureGroupingExists(answerGrouping);
            }
            else {
                ChartSetupDataBinding.DeleteGroupingByValue(groupTypes.ANSWER_VAL);
            }

            HTMLHelpers.setSelectedValues('#ddlCalculationType', calculationType);
            HTMLHelpers.setSelectedValues('#numericPercentileValue', numericPercentileValue);

            if (calculationType == '11') {
                $('#numericPercentileValue').show();
                $('#sbTextNumericPercentile').show();
            }
            else {
                $('#numericPercentileValue').hide();
                $('#sbTextNumericPercentile').hide();
            }

            if ((calculationType == '8') || (calculationType == '9') || (calculationType == '10') || (calculationType == '11'))
                $('#sbTextNumericNote').show();
            else
                $('#sbTextNumericNote').hide();

            var showSelected = $("#ddlShowBase").val() || "";
            var trimSelected = $("#ddlTrimLowBase").val() || "";
            var warnSelected = $("#ddlWarnLowBase").val() || "";

            if (calculationType == "2" && $("#hdnExclAverage").val() == "1") {
                $('#ddlShowBase').empty().append($showBaseSelOptions);
                $('#ddlTrimLowBase').empty().append($trimLowBaseOtions);
                $('#ddlWarnLowBase').empty().append($warnLowBaseOptions);
            }
            else {
                $('#ddlShowBase').empty().append($showBaseSelOptions.filter('.nonavg'));
                $('#ddlTrimLowBase').empty().append($trimLowBaseOtions.filter('.nonavg'));
                $('#ddlWarnLowBase').empty().append($warnLowBaseOptions.filter('.nonavg'));
            }
            if ($("#ddlShowBase option[value='" + showSelected + "']").length > 0)
                $('#ddlShowBase').val(showSelected);
            else
                $('#ddlShowBase').val("0");

            if ($("#ddlTrimLowBase option[value='" + trimSelected + "']").length > 0)
                $('#ddlTrimLowBase').val(trimSelected);
            else
                $('#ddlTrimLowBase').val("1");

            if ($("#ddlWarnLowBase option[value='" + warnSelected + "']").length > 0)
                $('#ddlWarnLowBase').val(warnSelected);
            else
                $('#ddlWarnLowBase').val("1");

			if (calculationType == "2" || calculationType == Storyboard.Constants.CalculationTypes.NUMERIC_AVERAGE) {
                $('#txtRespondentLimit').closest('span').hide();
            } else {
                $('#txtRespondentLimit').closest('span').show();
            }

            ChartSetupUI.hideAnswerSelections(consts.CalculationTypes.isAnswerBased(calculationType));
            ChartSetupUI.hideCorrelationSettings(calculationType == consts.CalculationTypes.CORRELATION_ANALYSIS);
            ChartSetupUI.disableForCalcType(calculationType);
            this.SetDataGroupingSelections(ChartSetupDataBinding.GetBoundDataGroup());
            if (HeatMapQuickSetup.isLoaded === true) {
                HeatMapQuickSetup.setupLegendSelections(consts.CalculationTypes.isAnswerBased(calculationType));
                HeatMapQuickSetup.updateLegendDropZone();
            }

            //base variable selection application only for categorical percent and numeric mean
            if (calculationType == 1 || calculationType == 3) {
                $('#hdBaseVariableOptions').show();
            }
            else {
                $('#hdBaseVariableOptions').hide();
            }

            // Calculation type categorical mean or % or numeric mean
			if (calculationType < 3 || calculationType == Storyboard.Constants.CalculationTypes.NUMERIC_AVERAGE) {
                var seriesType = parseInt($('#ddlSeriesType').val(), 10);
                var st = Storyboard.Constants.SeriesTypes;

                $('#hdCalculationOptions').hide();
                $('#ddlGroupDataBy').val('0');

				if (calculationType != consts.CalculationTypes.CATEGORICAL_COUNT &&
					!$('#chbShowOnlyBenchmarks').attr('checked') && !(seriesType == st.PIE || seriesType == st.DONUT ||
						seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE || seriesType == st.SCATTER || seriesType == st.BUBBLE)) {
					$('.hdStatistics').show();

					var isNumericAvg = calculationType == Storyboard.Constants.CalculationTypes.NUMERIC_AVERAGE;
                    if (isNumericAvg)
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='1']"));
                    else
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), '[value="1"]'));

                    // paired sig test - mean and % categorical
                    if (calculationType <= 2) {
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), '[value="4"]'));
                        HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), '[value="5"]'));                        
                    } else {
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='4']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='5']"));
                    }

					ChartSetupUI.configureSigTestType(calculationType);
				}
                else {
                    if (ChartSetupUI.checkIfNormTestAvailable(calculationType)) {
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='1']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='3']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='4']"));
                        HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='5']"));
                        $("#ddlAnalysisType").children("option[value='2']").attr('selected', true);
						ChartSetupUI.configureSigTestType(calculationType);
                    } else {
                        $('.hdStatistics').hide();
                    }
                }
            } else {
                if (ChartSetupUI.checkIfNormTestAvailable(calculationType)) {
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='1']"));
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='3']"));
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='4']"));
                    HTMLHelpers.optionToComment($("#ddlAnalysisType option[value='5']"));
                    $("#ddlAnalysisType").children("option[value='2']").attr('selected', true);
					ChartSetupUI.configureSigTestType(calculationType);
                } else {
                    $('#hdCalculationOptions').hide();
                    $("#chkSignificance").attr('checked', false).trigger('change');
                    $('.hdStatistics').hide();
                }
            }

            if (optionalChartSettings == null || optionalChartSettings.seriesTypes == null) {
                if ($('.dataGroupsSelections').children('[dgguid]').length > 1 // do not display TreeMap chart in dropdown if we have multiple series defined
                || (isMainDg != null && !isMainDg)) {
                    hideOption($('#ddlSeriesType'), consts.SeriesTypes.TREEMAP);
                    hideOption($('#ddlSeriesType'), consts.SeriesTypes.HEATMAP);
                    hideOption($('#ddlSeriesType'), consts.SeriesTypes.MARIMEKKO);
                } else {
                    showOption($('#ddlSeriesType'), consts.SeriesTypes.TREEMAP);
                    showOption($('#ddlSeriesType'), consts.SeriesTypes.HEATMAP);
                    showOption($('#ddlSeriesType'), consts.SeriesTypes.MARIMEKKO);
                }
            }
        },
        SetDataGroupingSelections: function (dataGroup) {
            $("#lbAxisList, #lbLegendList, #lbAxisList ul, #lbLegendList ul").sortable("destroy");

            var nested = $("#chbNestCompareFilters").is(':checked');

            var axisItems = $.grep(dataGroup.groupedItems, function (e, i) {
                return e.position == Storyboard.Constants.Axis.axis;
            });

            var legendItems = $.grep(dataGroup.groupedItems, function (e, i) {
                return e.position == Storyboard.Constants.Axis.legend;
            });

            var legendItemsNested;

            if (nested) {
                legendItemsNested = legendItems;
            } else {
                legendItemsNested = $.grep(legendItems, function (e, i) {
                    return e.groupType !== 3;
                });

                var nestedValue = $.map(legendItems, function (e, i) {
                    if (e.groupType === 3 && e.value != "0" && e.value) return e.value;
                }).join(",");

                var nestedText = $.map(legendItems, function (e, i) {
                    if (e.groupType === 3 && e.value != "0" && e.text) return e.text.replace(/Filter \(|\)$/g, "");
                }).join(", ");

                if (nestedValue.length > 1 && nestedText.length > 1) {
                    var filGrp = {
                        value: nestedValue,
                        text: locale.get("Filters") + " (" + nestedText + ")"
                    };

                    legendItemsNested.push(filGrp);
                }
            }

            dataGroup.sortingInfo.axisSortKey = mapSortKeys(legendItems);
            dataGroup.sortingInfo.legendSortKey = mapSortKeys(axisItems);

            HTMLHelpers.bindSelect('#lbLegend', legendItems, 'value', 'text');
            HTMLHelpers.bindSelect('#lbAxis', axisItems, 'value', 'text');

            HTMLHelpers.bindSelect('#ddlTopValuesSubgroups', legendItemsNested, 'value', 'text', 'No Selection', true);
			HTMLHelpers.bindSelect('#ddlMeanSeriesSubgroup', legendItemsNested, 'value', 'text', 'No Selection', true);
			HTMLHelpers.bindSelect('#ddlAggregatedSeriesSubgroup', legendItemsNested, 'value', 'text', 'No Selection', true);

            if (HeatMapQuickSetup.isLoaded) {
                HeatMapQuickSetup.updateFiltersList(dataGroup);
                HeatMapQuickSetup.updateAxesDropZones(dataGroup);
            } else {
                HTMLHelpers.bindUL('#lbLegendList', legendItems, 'value', 'text', 'text', 'groupingsConnectItem');
                HTMLHelpers.bindUL('#lbAxisList', axisItems, 'value', 'text', 'text', 'groupingsConnectItem');

                ChartSetupUI.updateGroupingsAvailabillity('question', $('#questionBox'));
				ChartSetupUI.updateGroupingsAvailabillity('answer', $('#answerbox'));
                ChartSetupUI.updateGroupingsAvailabillity('timeperiod', $('#ddlInterval'));
                ChartSetupUI.updateNestedFiltersGroupings();

                $("#lbAxisList, #lbLegendList, #lbAxisList ul, #lbLegendList ul").sortable({
                    appendTo: document.getElementById('setupHolder'),
                    helper: "clone",
                    items: '> li',
                    //axis: "y",
                    connectWith: ".groupingsConnect",
                    cancel: ".ui-state-disabled",
                    receive: function (event, ui) { ChartSetupUI.dragItems(event, ui); },
                    stop: function (event, ui) { ChartSetupUI.changeOrderDrag(event, ui); }
                });

                var connectWithAxis = "#lbLegendList" + (($("#lbLegendList ul").length > 0) ? " ul" : "");
                var connectWithLegend = "#lbAxisList" + (($("#lbAxisList ul").length > 0) ? " ul" : "");

                $("#lbAxisList ul").sortable("option", "connectWith", connectWithAxis);
                $("#lbLegendList ul").sortable("option", "connectWith", connectWithLegend);
            }

            var selectedBenchmarkFilter = -1;
            if (dataGroup.benchmarkSettings && dataGroup.benchmarkSettings.value != '-1')
                selectedBenchmarkFilter = dataGroup.benchmarkSettings.value;

            ChartSetupUI.updateBenchmarkOptions(selectedBenchmarkFilter);
            ChartSetupUI.updateRankingObjects(dataGroup.rankSettings ? dataGroup.rankSettings.rankObject : "-1");
            ChartSetupUI.updateRankingOptionalFilters(dataGroup.rankSettings ? dataGroup.rankSettings.optionalFilterItem : "-1");
            ChartSetupUI.updateSigTestOptions(dataGroup.significanceOptions.dataCompareType, dataGroup.significanceOptions.dataCompareItem);
            ChartSetupUI.updateHeatMapLegendBox();
            ChartSetupUI.updateSortingOptions();
        },
        SetSelectedSeriesSettings: function (seriesSettings) {
            HTMLHelpers.setSelectedValues('#ddlSeriesType', seriesSettings.seriesType);
            $("#ddlSeriesType").attr('data-selected-type', seriesSettings.seriesType);
            ChartSetupUI.disableForSeriesType(seriesSettings.seriesType);
            HTMLHelpers.setSelectedValues('#ddlSeriesOptions', seriesSettings.seriesAttribute);
            HTMLHelpers.setSelectedValues('#ddlSeriesLayoutOptions', seriesSettings.seriesLayoutAlgorithm);
            if (seriesSettings.seriesType != Storyboard.Constants.SeriesTypes.HEATMAP)
                HTMLHelpers.setSelectedValues('#ddlColorLogic', seriesSettings.seriesColorSource);
            HTMLHelpers.setSelectedValues('#ddlGradientType', seriesSettings.seriesGradientType);
            HTMLHelpers.setSelectedValues('#ddlColorValueSource', seriesSettings.seriesColorValueSource);
            $('#txtGradientMinValue').val(seriesSettings.seriesGradientMinValue);
            $('#txtGradientMaxValue').val(seriesSettings.seriesGradientMaxValue);
            HTMLHelpers.setSelectedValues('#ddlLegendPosition', seriesSettings.legendPosition);
            HTMLHelpers.setSelectedValues('#ddlShowTopSeriesOrientation', seriesSettings.showTopSeriesOrientation);
            HTMLHelpers.setSelectedValues('#ddlShowTopSeriesMode', seriesSettings.showTopSeriesMode);
            HTMLHelpers.setSelectedValues('#ddlShowTopValuesPerGroupOrientation', seriesSettings.showTopValuesPerGroupOrientation);
			HTMLHelpers.setSelectedValues('#ddlTopValuesSubgroups', seriesSettings.showTopValuesSubgroup);
            HTMLHelpers.setSelectedValues('#dllGenerateByDecimals', seriesSettings.renderValueType);
            HTMLHelpers.setSelectedValues('#ddlRunTopSeriesAfterOp', seriesSettings.runTopSeriesAfterRankSigTestBm == false ? 0 : 1);
            $('#chbExcludeZeroFromTopBottom').attr("checked", seriesSettings.excludeZeroFromTopSeries);
            $('#chbUseTableCellGradient').attr("checked", seriesSettings.useTableHeatmapColors);

            $("#ddlShowTopSeriesMode").change();

            $("#txtShowTopSeries").val(seriesSettings.showTopSeries);
            $("#txtShowTopSeriesTo").val(seriesSettings.showTopSeriesTo);
            $("#txtShowTopValuesPerGroup").val(seriesSettings.showTopValuesPerGroup);
            $("#cbShowValues").attr("checked", seriesSettings.showDataLabel || seriesSettings.seriesType == Storyboard.Constants.SeriesTypes.HEATMAP);
            $("#chkInvertChart").attr("checked", seriesSettings.invertChart);
            $("#txtNoofDecimals").val(seriesSettings.noofDecimals);
            $("#chbMatchXAxisOnText").attr("checked", seriesSettings.matchXaxisOnText);
            $("#chkApplyPosNeg").attr("checked", seriesSettings.isPosNeg);
            //you can only show unit text in data label if data label is enabled, obviously
            //but we set this property for whole chart (sub series too, which can show labels when main series does not)
            $("#chkShowUnitOnDataLabel").attr("checked", seriesSettings.showUnitOnDataLabel);
            $("#chbShowSeparatorOnDataLabel").attr("checked", seriesSettings.showSeparatorOnDataLabel);
            $("#chbExcelExportAllSeries").attr("checked", seriesSettings.exportAllSeriesToExcel);

            var hexSeriesColor = Helpers.convertFromDecimalToHex(seriesSettings.seriesColor);
            $('#seriesColorPreview').DUIColorPicker({
                layout: 'template',
                transparent: false,
                selected: {
                    colorString: hexSeriesColor,
                    templateColorId: seriesSettings.seriesColor_colorPlaceholderId
                }
            });

            // remove all dynamic color stops except for template
            $('#dynamicColorsTable tr[id^="dynamicColorStop_"]').remove();

            var $dynamicColorStopTemplate = $('#dynamicColorStopTemplate');

            // set default dynamic color stops
            if (!seriesSettings.colorStops || seriesSettings.colorStops.length === 0) {
                seriesSettings.colorStops = [
                    { color: Helpers.convertFromHexToDecimal('#c0504e'), stop: 0 },
                    { color: Helpers.convertFromHexToDecimal('#9bbb58'), stop: 100 }
                ];
            }

            seriesSettings.colorStops.forEach(function (colorStop, index) {
                if (index === 0)
                    ChartSetupUI.addSeriesColorStop($dynamicColorStopTemplate);
                else {
                    var $lastColorStop = $('#dynamicColorsTable tr[id^="dynamicColorStop_"]').last();
                    ChartSetupUI.addSeriesColorStop($dynamicColorStopTemplate, $lastColorStop);
                }

                var hexStopColor = Helpers.convertFromDecimalToHex(colorStop.color);
                $('#dynamicColorStop_' + index).find('#dynamicColorPreview_' + index)
                    .DUIColorPicker({
                        layout: 'template',
                        transparent: false,
                        selected: {
                            colorString: hexStopColor,
                            templateColorId: colorStop.colorPlaceholderId
                        }
                    });

                $('#dynamicColorStop_' + index).find('#dynamicColorStopValue_' + index).val(colorStop.stop);
            });

            //value based coloring

            //remove all 

            $('#tblValueBasedColors tr[id^="valueBasedColor_"]').remove();

            var $ValueBasedColorsTemplate = $('#ValueBasedColorsTemplate');

            // set default dynamic color stops
            if (!seriesSettings.valueBasedColoring || seriesSettings.valueBasedColoring.length === 0) {
                seriesSettings.valueBasedColoring = [
                    {
                        color: Helpers.convertFromHexToDecimal('#c0504e'),
                        colorHex: '#c0504e'
                    },
                ];
            }

            seriesSettings.valueBasedColoring.forEach(function (vaBsdColor, index) {
                if (index === 0)
                    ChartSetupUI.addValueBasedColor($ValueBasedColorsTemplate);
                else {
                    var $lastColorStop = $('#tblValueBasedColors tr[id^="valueBasedColor_"]').last();
                    ChartSetupUI.addValueBasedColor($ValueBasedColorsTemplate, $lastColorStop);
                }

                var hexStopColor = Helpers.convertFromDecimalToHex(vaBsdColor.color);
                $('#valueBasedColor_' + index).find('#ValueBasedColorsPreview_' + index)
                    .DUIColorPicker({
                        layout: 'template',
                        transparent: false,
                        selected: {
                            colorString: hexStopColor,
                            templateColorId: vaBsdColor.colorPlaceholderId
                        }
                    });

                $('#valueBasedColor_' + index).find('#valueBasedStartValue_' + index).val(vaBsdColor.startValue);
                $('#valueBasedColor_' + index).find('#valueBasedStopValue_' + index).val(vaBsdColor.endValue);
                Helpers.setupNumericTextbox('#valueBasedStartValue_' + index);
                Helpers.setupNumericTextbox('#valueBasedStopValue_' + index);
                $('#valueBasedColor_' + index).find('#valueBasedStartCondition_' + index).val(vaBsdColor.startConditionValue);
                $('#valueBasedColor_' + index).find('#valueBasedStopCondition_' + index).val(vaBsdColor.endConditionValue);
            });


            $('#seriesColorCategory').val(seriesSettings.seriesColorCategoryId);

            setBitFlags('.seriesTrimming', seriesSettings.seriesStripSettings.seriesStripType);
            $('#chbMatchseries').attr("checked", seriesSettings.matchSeriesOnColumnText);
            $('#chbMatchSeriesRows').attr("checked", seriesSettings.matchSeriesOnRowText);

			$("#chbUseTwoColorLogic").attr("checked", seriesSettings.useTwoLabelColorLogic);
			
			$("#txtLabelColorForLightBg").DUIColorPicker({
				layout: 'template',
				transparent: false,
				selected: {
					colorString: (seriesSettings.labelColorForLightBg || "#000000"),
					templateColorId: seriesSettings.labelColorForLightBg_colorPlaceholderId
				}
			});
			$("#txtLabelColorForDarkBg").DUIColorPicker({
				layout: 'template',
				transparent: false,
				selected: {
					colorString: (seriesSettings.labelColorForDarkBg || "#ffffff"),
					templateColorId: seriesSettings.labelColorForDarkBg_colorPlaceholderId
				}
			});

            ChartSetupUI.enableDisableTopSeriesSettings();
            ChartSetupUI.showHideTopSeriesRangeOptions();
            ChartSetupUI.showHideBeforeAfterTopSeries();
            ChartSetupUI.showHideExcludeZeroFromTop();

            ChartSetupUI.showHideColorPickerForSeries();
            ChartSetupUI.showHideTwoColorControls();
            ChartSetupUI.showHideValueBasedColors();
            ChartSetupUI.disableMatchOnText();
        },
        SetSelectedHeatmapSettings: function (heatmapSettings) {
            $("#chbAutoGradient").attr("checked", heatmapSettings.autoGradient);
            ChartSetupUI.disableCustomGradient();
            $("#chbAutoRadius").attr("checked", heatmapSettings.autoRadius);
            ChartSetupUI.disableCustomRadius();
            $("#txtCustomRadius").val(heatmapSettings.radius || 0);
            $("#txtOpacity").val(heatmapSettings.opacity || 100);
            HTMLHelpers.setSelectedValues("#ddlHeatMapLegend", heatmapSettings.legendItemTypeId || 0);
            HTMLHelpers.setSelectedValues("#ddlHMLegendPosition", heatmapSettings.legendPosition || "br");
        },
		SetSelectedSeriesStripSettings: function (seriesStripSettings, isMain) {
			$('#chbTrimLowBaseByMain').attr('checked', seriesStripSettings.applyMainHideLowBaseSettings);
			$('#chbTrimLowResultByMain').attr('checked', seriesStripSettings.applyMainHideLowResultSettings);
			$('#chbWarnLowBaseByMain').attr('checked', seriesStripSettings.applyMainWarnLowBaseSettings);

            $('#txtTrimLowBase').val(seriesStripSettings.hideSeriesLimit);
            $('#ddlTrimType').val(seriesStripSettings.hideSeriesType);
            HTMLHelpers.setSelectedValues('#ddlTrimLowBase', seriesStripSettings.hideValueType);
            $('#txtTrimLowBaseMessage').val(seriesStripSettings.hideSeriesMessage);
            $('#txtWarnLowBase').val(seriesStripSettings.warningLimit);
            HTMLHelpers.setSelectedValues('#ddlWarnLimits', seriesStripSettings.baseSizeWarningLimitId);
            HTMLHelpers.setSelectedValues('#ddlHideLimits', seriesStripSettings.baseSizeHideLimitId);
            HTMLHelpers.setSelectedValues('#ddlWarnLowBase', seriesStripSettings.warningValueType);
            $('#txtWarnLowBaseMessage').val(seriesStripSettings.warningMessage);

            HTMLHelpers.setSelectedValues("#ddlTrimLowResultObject", seriesStripSettings.hideLowResultObject);
            $("#txtTrimLowResultValue").val(seriesStripSettings.hideLowResultLimit);
            HTMLHelpers.setSelectedValues("#ddlTrimLowResultUseWeight", seriesStripSettings.hideLowResultBaseType);
            HTMLHelpers.setSelectedValues("#ddlTrimLowResultType", seriesStripSettings.hideLowResultType);
			$("#txtTrimLowResultMessage").val(seriesStripSettings.hideLowResultMessage);

			ChartSetupUI.showHideSubseriesLowResult();

            ChartSetupUI.toggleCustomWarnLimit();
            ChartSetupUI.toggleCustomHideLimit(); 
            ChartSetupUI.disableHideLowBase();
            ChartSetupUI.disableHideLowResult();
            ChartSetupUI.disableHideLowResultBaseType();
            ChartSetupUI.disableWarnLowBase();
            ChartSetupUI.showHideThresholdSettings();
            ChartSetupUI.enableValuesPerGroup();
        },
        SetTextOptions: function (textoptions, customHeaders) {
            $("#cbShowQuestionTexts").attr("checked", textoptions.showQuestionTexts);
            $("#cbShowAnswerTexts").attr("checked", textoptions.showAnswerTexts);
            $("#cbShowFilterTexts").attr("checked", textoptions.showFilterTexts);
            $("#cbShowTimeIntervalTexts").attr("checked", textoptions.showTimeIntervalTexts);
            $("#cbShowThousandSeparator").attr("checked", textoptions.showThousandSeparator);
            $("#chbShowPositivePrefix").attr("checked", textoptions.showPositivePrefix);

            $("#chkEnableCustomColumnHeaders").attr("checked", textoptions.useCustomColumnHeaders);
            $("#chkEnableCustomRowHeaders").attr("checked", textoptions.useCustomRowHeaders);

            ChartSetupUI.enableCustomHeaders();

            // clear headers tables
            $("#tblCustomColumnHeaders > tbody > .customHeaderRow:not('.customHeaderTemplate'), " +
                "#tblCustomRowHeaders > tbody > .customHeaderRow:not('.customHeaderTemplate')").remove();

            if (customHeaders) {
                var rowTemplateClass = "customHeaderTemplate";

                $(customHeaders).each(function () {
                    var tableId = this.axis == 1 ? "tblCustomRowHeaders" : "tblCustomColumnHeaders";
                    var newRow = ChartSetupUI.addRowFromTemplate(tableId, rowTemplateClass, { layout: 'template' });

                    newRow.find("#hidCustomHeaderId").val(this.headerId);
                    newRow.find("#ddlHeaderType").val(this.type);
                    newRow.find("#txtHeaderText").val(this.text);
                    newRow.find("#ddlHeaderSortOrder").val(this.sortOrder);
                    newRow.find("#ddlNestingLevel").val(this.nestingLevel);
                    newRow.find("#btnDeleteCustomHeader").bind("click", function () {
                        ChartSetupUI.removeRow(this, "customHeaderRow");
                    });
                });
            }
        },
        SetAxisOptions: function (dataGroup, contentType) {
            if (dataGroup.axisOptions) {
                $("#txtXAxis").val(dataGroup.axisOptions.xAxisText);
                $("#txtYAxis").val(dataGroup.axisOptions.yAxisText);
                $("#txtMinScale").val(dataGroup.axisOptions.minScale);
                $("#txtMaxScale").val(dataGroup.axisOptions.maxScale);
                $('#txtAxisUnitName').val(dataGroup.axisOptions.axisUnitName);
                $('#ddlAxisUnitPlacement').val(dataGroup.axisOptions.axisUnitPlacement);
                $('#chbShowUnitOnYAxis').attr("checked", dataGroup.axisOptions.showUnitOnYaxis);
                $('#chbShowSeparatorOnYAxis').attr("checked", dataGroup.axisOptions.showSeparatorOnYaxis);
                $('#chkAutoGrid').attr("checked", dataGroup.axisOptions.autoGrid).trigger('change');
                $("#txtGridInterval").val(dataGroup.axisOptions.gridInterval);
            }

            var isScatterLike = Storyboard.Constants.SeriesTypes.isScatterLike(dataGroup.seriesSettings.seriesType);
            var showAxisPanel = contentType == Storyboard.Constants.itemTypes.SIMPLETABLE || dataGroup.useSecondaryAxis || dataGroup.isMain || isScatterLike;
            var useSecondaryAxis = dataGroup.useSecondaryAxis;

            this.ToggleAxisPanel(showAxisPanel, useSecondaryAxis);
        },
        SetDefaultAxisBehavior: function (dataGroup) {
            if (dataGroup.defaultAxisBehavior) {
                $('#selectDefaultPlacementInterval').
                    val(dataGroup.defaultAxisBehavior.intervalPosition.toString());
                $('#selectDefaultPlacementFilters').
                    val(dataGroup.defaultAxisBehavior.filtersPosition.toString());
            }
        },
        SetCalculationOptions: function (dataGroup) {

            var calculationType = $('#ddlCalculationType option:selected').val();

            if (calculationType == '11') {
                $('#numericPercentileValue').show();
                $('#numericPercentileValue').val(dataGroup.numericPercentileValue);
            }
            else
                $('#numericPercentileValue').hide();

            if ((calculationType == '8') || (calculationType == '9') || (calculationType == '10') || (calculationType == '11'))
                $('#sbTextNumericNote').show();
            else
                $('#sbTextNumericNote').hide();

            $('#ddlBaseVariable').val('0');
            // Calculation type not mean numeric or categorical percent
            if (calculationType == 1 || calculationType == 3 || calculationType == 7) {
                $('#hdBaseVariableOptions').show();
                if (dataGroup.calculationOptions &&
                    dataGroup.calculationOptions.baseVariable !== null &&
                    typeof (dataGroup.calculationOptions.baseVariable) !== 'undefined') {
                    $('#ddlBaseVariable').
                        val(dataGroup.calculationOptions.baseVariable.toString());
                }
            } else {
                $('#hdBaseVariableOptions').hide();
                $('#ddlBaseVariable').val('0');
            }

			// Calculation type not numeric
			if (calculationType < 3 || calculationType == Storyboard.Constants.CalculationTypes.NUMERIC_AVERAGE) {
                $('#hdCalculationOptions').hide();
                $('#ddlGroupDataBy').val('0');
            } else {
                //hide old group data by option
                $('#hdCalculationOptions').hide();
                $('#ddlGroupDataBy').val('0');

                // Disable sig. calculations for numeric questions.
                $("#chkSignificance").attr('checked', false).trigger('change');
                $('.hdStatistics').hide();
            }

            //rebase percentage share 
            if (calculationType == Storyboard.Constants.CalculationTypes.CATEGORICAL_PERCENT) {
                $('#rbRebasePercentageShare').attr("checked", !dataGroup.calculationOptions.rebasePercentageShare);
                $('#rbTotalBase').attr("checked", dataGroup.calculationOptions.rebasePercentageShare && dataGroup.calculationOptions.rebasePercentageShareUsingTotalBase);
                $('#rbFromOtherQuestion').attr('checked', dataGroup.calculationOptions.rebasePercentageShare && !dataGroup.calculationOptions.rebasePercentageShareUsingTotalBase);
                $('#ddlRebaseVariable').val(dataGroup.calculationOptions.rebasePercentageShareQuestionId);

                if (dataGroup.calculationOptions.rebasePercentageShare && !dataGroup.calculationOptions.rebasePercentageShareUsingTotalBase) {
                    $('#rebaseVariableBox').show();
                } else {
                    $('#rebaseVariableBox').hide();
                }

                $('#rebasePercentageShareSettings').show();
                $('.qaBaseCalculation').toggle($('.qaBaseCalculation .settingsGroup').filter(function(i, el) { return el.style.display !== 'none' }).length > 0);
            } else {
                $('#rbRebasePercentageShare').attr("checked", true);
                $('#rbTotalBase').attr("checked", false);
                $('#rbFromOtherQuestion').attr("checked", false);
                $('#rebaseVariableBox').hide();
                $('#rebasePercentageShareSettings').hide();
                $('.qaBaseCalculation').toggle($('.qaBaseCalculation .settingsGroup').filter(function(i, el) { return el.style.display !== 'none' }).length > 0);
            }
        },
        SetMeanSeriesSettings: function (meanSeriesSettings) {
            $("#chbEnableMeanValueSeries").attr("checked", meanSeriesSettings ? meanSeriesSettings.enabled : false);
            $("#chbConsiderBase").attr("checked", meanSeriesSettings ? meanSeriesSettings.considerBase : false);
            $("#chbHideOriginalSeries").attr("checked", meanSeriesSettings ? meanSeriesSettings.hideOriginalSeries : false);
            $("#ddlMeanValueOrientation").val(meanSeriesSettings ? meanSeriesSettings.orientation : 1);
            $("#ddlMeanSeriesPosition").val(meanSeriesSettings ? meanSeriesSettings.position : 1);
            $("#txtMeanSeriesLabel").val(meanSeriesSettings ? meanSeriesSettings.label : "");
            $("#ddlMeanSeriesSubgroup").val(meanSeriesSettings ? meanSeriesSettings.subgroup : 0);			
            $("#txtMeanSeriesColor").DUIColorPicker({
                layout: 'template',
                selected: {
                    colorString: meanSeriesSettings ? meanSeriesSettings.color : "",
                    templateColorId: meanSeriesSettings ? meanSeriesSettings.color_colorPlaceholderId : ""
                }
            });

            ChartSetupUI.disableMeanSeries();
            ChartSetupUI.disableMeanSeriesPosition();
            ChartSetupUI.disableMeanSeriesColor();
            ChartSetupUI.disableMeanSeriesSubgroup();
        },
        SeAggregatedSeriesSettings: function (aggrSeriesSettings) {
            $("#chbEnableAggregatedSeries").attr("checked", aggrSeriesSettings ? aggrSeriesSettings.enabled : false);
			$("#chbAggrHideOriginalSeries").attr("checked", aggrSeriesSettings ? aggrSeriesSettings.hideOriginalSeries : false);
			$('#chbAggrStopOnMissingValue').attr('checked', aggrSeriesSettings ? aggrSeriesSettings.stopOnMissingValue : false);
            $("#ddlAggrSeriesOrientation").val(aggrSeriesSettings ? aggrSeriesSettings.orientation : 1);
            $("#ddlAggregatedSeriesPosition").val(aggrSeriesSettings ? aggrSeriesSettings.position : 1);
            $("#txtAggregatedSeriesLabel").val(aggrSeriesSettings ? aggrSeriesSettings.label : "");
            $("#ddlAggregatedSeriesSubgroup").val(aggrSeriesSettings ? aggrSeriesSettings.subgroup : 0);
            $("#txtAggregatedSeriesColor").DUIColorPicker({
                layout: 'template',
                selected: {
                    colorString: aggrSeriesSettings ? aggrSeriesSettings.color : "",
                    templateColorId: aggrSeriesSettings ? aggrSeriesSettings.color_colorPlaceholderId : ""
                }
            });

			ChartSetupUI.disableAggregatedSeries();
			ChartSetupUI.disableAggregatedSeriesPosition();
			ChartSetupUI.disableAggregatedSeriesColor();
			ChartSetupUI.disableAggregatedSeriesSubgroup();
		},
        SetOptionalFilterSettings: function (datagroup) {
            $("#chbUseMainOptFilterSettings").attr("checked", !datagroup.isMain && datagroup.useMainOptionalFilterSettings);
            ChartSetupUI.hideOptionalFilters();

            $('.chkOptFilter').attr('checked', true);

            $(datagroup.optionalFilterSettings).each(function () {
                if (!this.optionalSettingType) {
                    $("#optionalFilterSettings").find("input[type=checkbox]").each(function () {
                        $(this).attr("checked", true);
                    });
                    return;
                }
                if (this.optionalSettingType == 1) {
                    $("#chkOptVariableSubset").attr("checked", this.isApply);
                }
                else if (this.optionalSettingType == 2) {
                    $("#chkOptHFilter").attr("checked", this.isApply);
                }
                else if (this.optionalSettingType == 3) {
                    DataGroupSelections.setOptionalFilterQuestions(this.questionId, this.isApply);
                }
                else if (this.optionalSettingType == 4) {
                    $("#chkOptTimePeriod").attr("checked", this.isApply);
                    $("#chkOptDateVariable").attr("checked", this.isApplyDateVariable);
                }
                else if (this.optionalSettingType == 5) {
                    $("#chkOptInterval").attr("checked", this.isApply);
                }
                else if (this.optionalSettingType == 6) {
                    $("#chkOptMovingAverage").attr("checked", this.isApply);
                }
            });

            var allChecked = $('#optionalFilterSettings input[type="checkbox"]')
                .filter(function () { return $(this).attr('id') !== 'chkOptFilter'; })
                .filter(function () { return !$(this).is(':checked'); })
                .length === 0;

            $('#optionalFilterSettings')
                .prev('.optionalFilterSettingsCheckAll').find('input[type="checkbox"]')
                .attr('checked', allChecked);
        },
        setOptionalFilterQuestions: function (questionId, isApply) {
            var boxes = $("#optionalFilterBox div");
            for (var i = 0; i < boxes.length; i++) {
                if (questionId == parseInt($(boxes[i]).find("#hidOptQuestionId").val() || "0")) {
                    $(boxes[i]).find(".chkOptFilter").attr("checked", isApply);
                    break;
                }
            }
        },
        SetThreshold: function (datagroup) {
            if (datagroup.useThreshold) {
                $('#chbThreshold').attr('checked', 'checked');
                $('.thresholdSettings').show();
                $('#txtThresholdValue').val(datagroup.thresholdValue);
                $('#txtColorAbove')
                    .DUIColorPicker({
                        layout: 'template',
                        selected: {
                            colorString: datagroup.colorAbove,
                            templateColorId: datagroup.colorAbove_colorPlaceholderId
                        }
                    }).trigger('change');
                $('#txtColorBelow')
                    .DUIColorPicker({
                        layout: 'template',
                        selected: {
                            colorString: datagroup.colorBelow,
                            templateColorId: datagroup.colorBelow_colorPlaceholderId
                        }
                    }).trigger('change');
            }
            else {
                $('#chbThreshold').removeAttr('checked');
                $('.thresholdSettings').hide();
                $('#txtThresholdValue').val('');
                $('#txtColorAbove').val('#ffffff').trigger('change');
                $('#txtColorBelow').val('#ffffff').trigger('change');
            }
        },
        SetPercentiles: function (datagroup) {
            $('#chkPercentile').attr('checked', datagroup.usePercentile);
            if ($('#chkPercentile').attr('checked')) {
                $("#ddlSeriesOptions option[value='2']").attr("disabled", 'disabled');
				$("#ddlSeriesOptions option[value='1']").attr('selected', 'selected');
				$('#percentilePanel').children().not(':first').not(':nth-child(2)').show();
            } else {
                if (Storyboard.Constants.SeriesTypes.isStackable(datagroup.seriesSettings.seriesType))
                    $("#ddlSeriesOptions option[value='2']").removeAttr("disabled");
                $('#percentilePanel').children().not(':first').not(':nth-child(2)').hide();
            }

            $('#startPercentile').val(datagroup.startPercentile);

            var table = $('#percentiles');
            table.find('.percentileRow').remove();

            if (datagroup.percentiles !== undefined && datagroup.percentiles !== null) {

                for (var i = 0; i < datagroup.percentiles.length; i++) {
                    var row = $('.percentileRowTemplate').first().clone();
                    row.css('display', '');

                    var value = datagroup.percentiles[i].Value != undefined ? datagroup.percentiles[i].Value : datagroup.percentiles[i].value;
                    var label = datagroup.percentiles[i].label != undefined ? datagroup.percentiles[i].label : datagroup.percentiles[i].Label;
                    var colour = datagroup.percentiles[i].colour != undefined ? datagroup.percentiles[i].colour : datagroup.percentiles[i].Colour;
                    var colour_colorPlaceholderId = datagroup.percentiles[i].colour_colorPlaceholderId != undefined ?
                         datagroup.percentiles[i].colour_colorPlaceholderId :
                         datagroup.percentiles[i].Colour_colorPlaceholderId;
                    var percentileId = datagroup.percentiles[i].percentileId != undefined ? datagroup.percentiles[i].percentileId : datagroup.percentiles[i].PercentileId;

                    row.find('.percentilePercentile').val(value);
                    row.find('.labelPercentile').val(label);
                    row.find('.colourPercentile')
                        .DUIColorPicker({
                            layout: 'template',
                            selected: {
                                colorString: colour,
                                templateColorId: colour_colorPlaceholderId
                            }
                        });
                    row.append('<input type="hidden" class="percentileId" value=' + percentileId + ' />');

                    row.addClass('percentileRow');
                    row.removeClass('percentileRowTemplate');

                    table.append(row);
                }
            }
        },
        InitializeAxisAndLegendListBox: function () {

        },
        IsFullPeriodIntervalSelected: function () {

            var timeInterval;
            var isFullPeriodIntervalSelected = false;

            timeInterval = $("#ddlInterval option:selected").val();

            if (timeInterval ===
                    Storyboard.Constants.IntervalTypes.FULL_PERIOD.toString()) {
                isFullPeriodIntervalSelected = true;
            }

            return isFullPeriodIntervalSelected;
        },
        DeleteGroupingCompletely: function (groupingValue) {
            if (ChartSetupDataBinding.CheckIfGroupingExists(groupingValue)) {
                $("#lbAxis option[title='Interval']").remove();
                $("#lbLegend option[title='Interval']").remove();
                ChartSetupDataBinding.DeleteGroupingByValue(groupingValue);
                ChartSetupDataBinding.SortGroupings();
            }
        },
        AddTimePeriodToGroupedItems: function (position) {
            var timePeriodValue = Storyboard.Constants.GroupTypes.TIMEPERIOD_VAL;

            // Insert time period grouping with sort order = 0.
            var timePeriodGrouping = Storyboard.Constants.GroupTypes.
                getGroupItem(timePeriodValue, position, 0, '');
            ChartSetupDataBinding.AddGrouping(timePeriodGrouping);

        },
        ToggleAxisPanel: function (showPanel, useSecondaryAxis) {
            var contentType = ChartSetupDataBinding.GetBoundContentType();
            $("#divAxisScale, #divAxisInterval").toggle(showPanel && contentType != Storyboard.Constants.itemTypes.HEATMAP);
            if (contentType == Storyboard.Constants.itemTypes.CHART) {
                $("#divAxisTexts > span:not(.positivePrefix)").toggle(showPanel);
                var seriesType = $('#ddlSeriesType').val();
                if (seriesType == Storyboard.Constants.SeriesTypes.TREEMAP) {
                    $('#txtXAxis').closest('.settingItem').hide();
                    $('#txtYAxis').closest('.settingItem').hide();
                } else if (seriesType == Storyboard.Constants.SeriesTypes.SCATTER || seriesType == Storyboard.Constants.SeriesTypes.BUBBLE) {
                    $('#txtYAxis').closest('.settingItem').hide();
				}
            } else if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE)
                $("#divAxisTexts").toggle(showPanel);
            useSecondaryAxis ? $("#chbUseSecondaryAxis").attr('checked', 'checked') : $("#chbUseSecondaryAxis").removeAttr('checked');
        },
		SetChartOptions: function (datagroup) {
            if (datagroup.chartOptions) {
                $("#chbShowFilterInTitle").attr("checked", datagroup.chartOptions.showFilterInTitle);
                $("#chbTransformIntoPolar").attr("checked", datagroup.chartOptions.transformIntoPolar);
                setBitFlags('.tooltipItems', datagroup.chartOptions.tooltipItems);
                $("#chbEnableTooltip").attr("checked", datagroup.chartOptions.enableTooltip);
                $("#chbShowMagnifyingGlass").attr("checked", datagroup.chartOptions.showMagnifyingGlass);
                if (datagroup.chartOptions.enableTooltip)
                    $('.tooltipItems').removeAttr('disabled');
                else
                    $('.tooltipItems').attr('disabled', 'disabled');

                ChartSetupUI.disableRespCountTooltip();

                $("#txtBaseSizeLabel").val(datagroup.chartOptions.baseSizeLabel);
                var contentType = ChartSetupDataBinding.GetBoundContentType();
                if (contentType == Storyboard.Constants.itemTypes.CHART) {
                    $("#ddlBasePosition").val(datagroup.chartOptions.baseSizePosition);
                    if (!datagroup.isMain) {
                        var mainDg = Storyboard.DataGroupLogic.getMainDataGroupForLayoutElementItem(datagroup.guid);
                        if (mainDg)
                            datagroup.chartOptions.baseSizeOption = mainDg.chartOptions.baseSizeOption;
                    }
                } else if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
                    $("#ddlTableBasePosition").val(datagroup.chartOptions.baseSizePosition || 3);
                    ChartSetupUI.updateBaseOrientation();
                }
                $("#ddlTableBaseOrientation").val(datagroup.chartOptions.baseSizeOrientation || 1);
                $(".baseSizeOption").val(datagroup.chartOptions.baseSizeOption);
                if ($("#hiddenZoom").val() == "1") {
                    $("#chartZooming").attr("checked", "checked");
                    $("#hiddenZoom").val("0");
                } else
                    $("#chartZooming").attr("checked", datagroup.chartOptions.allowChartZoom);

                $("#ddlGaugeDonutInnerRadius").val(datagroup.chartOptions.innerRadius);
                $("#chkAutoSeriesPointWidth").attr("checked", datagroup.chartOptions.autoColumnBarWidth);
            }

            ChartSetupUI.hideBasePosition();
            $("#chkAutoSeriesPointWidth").change();

            if (datagroup.detailTables && datagroup.detailTables.length > 0) {
                $("#lbDetailTables option:selected").removeAttr("selected");
                var dtIndex = 0, dt;
                for (; dtIndex < datagroup.detailTables.length; dtIndex++) {
                    dt = datagroup.detailTables[dtIndex];
                    $("#lbDetailTables option[value=" + dt.tableId + "]").attr("selected", "selected");
                }
            }
            else {
                $("#lbDetailTables").val(0);
            }
        },
        SetHFilterComparisonRules: function (dataGroup) {
            ChartSetupUI.clearHFilterComparison();

            if (!Storyboard.GeneralSettings.hasHFilter() || !Storyboard.HFilterLayout.hasHFilterNodes()) {
                ChartSetupUI.addHFilterToGrouping(false);
                return;
            }

            $(dataGroup.hFilterRules).each(function () {
                ChartSetupUI.addHFilterToComparison(this);
            });

            var hasComparisons = $("#hFilterSelectedComparisonGroups tr td.selection").length > 1;

            if (!hasComparisons)
                ChartSetupUI.addHFilterToGrouping(hasComparisons);

            var selectedBenchmarkFilter = 0;
            if (dataGroup.benchmarkSettings)
                selectedBenchmarkFilter = dataGroup.benchmarkSettings.value;

            ChartSetupUI.updateBenchmarkOptions(selectedBenchmarkFilter);
			ChartSetupUI.updateRankingObjects(dataGroup.rankSettings ? dataGroup.rankSettings.rankObject : "-1");
			ChartSetupUI.showHideHFilterColorSource();
        },
        SetSignificanceOptions: function (dataGroup) {
            var significanceOptions = dataGroup.significanceOptions;
            var allDgs = Storyboard.DataGroupLogic.getDataGroupsForLayoutElementItem(dataGroup);

            var $ddlNormSeries = $('#ddlNormSeries');
            $ddlNormSeries.empty();
            var useGuidSelectionValue = false;
            allDgs.forEach(function (dataGroup) {
                var optionValue;
                if (dataGroup.dataGroupId)
                    optionValue = dataGroup.dataGroupId;
                else if (dataGroup.dgGuid) {
                    optionValue = dataGroup.dgGuid;
                    useGuidSelectionValue = true;
                }

                if ($ddlNormSeries.children('option[value="' + optionValue + '"]').length == 0) {
                    $ddlNormSeries.append('<option value="' + optionValue + '" >' + dataGroup.groupName + '</option>');
                }

            });
            if (dataGroup.isMain) {
                HTMLHelpers.commentToOption(HTMLHelpers.getChildComments($('#ddlAnalysisType'), "option[value='" + (significanceOptions.analysisType == 0 ? 1 : significanceOptions.analysisType) + "']"));                
                var normDataGroupId = significanceOptions.normDataGroupId || significanceOptions.normDataGroupID;
                HTMLHelpers.setSelectedValues("#ddlNormSeries", useGuidSelectionValue ? significanceOptions.normDataGroupGuid : normDataGroupId);
            }
            HTMLHelpers.setSelectedValues("#ddlAnalysisType", significanceOptions.analysisType == 0 ? 1 : significanceOptions.analysisType);
            $("#chkSignificance").attr("checked", significanceOptions.isEnabled);
            $("#txtBaseLimit").val(significanceOptions.baseLimit);
            HTMLHelpers.setSelectedValues("#ddlSigTestLimitBase", significanceOptions.baseLimitType);
            $("#txtRespondentLimit").val(significanceOptions.respondentLimit);
			HTMLHelpers.setSelectedValues("#ddlDataTestType", significanceOptions.dataTestType == 0 ? 1 : significanceOptions.dataTestType);
			ChartSetupUI.showHideNoLetters();
            HTMLHelpers.setSelectedValues("#ddlSigResultToShow", significanceOptions.resultsToShow == 0 ? 1 : significanceOptions.resultsToShow);
            HTMLHelpers.setSelectedValues("#ddlDataCompareType", significanceOptions.dataCompareType == 0 ? 1 : significanceOptions.dataCompareType);
            HTMLHelpers.setSelectedValues("#ddlDataCompareItem", significanceOptions.dataCompareItem ? significanceOptions.dataCompareItem : 0);
            HTMLHelpers.setSelectedValues("#ddlSigLevel", significanceOptions.sigLevel == 0 ? 1.9606 : significanceOptions.sigLevel);
            HTMLHelpers.setSelectedValues("#ddlSigPlacementOption", significanceOptions.significancePlacement == 0 ? 1 : significanceOptions.significancePlacement);
            HTMLHelpers.setSelectedValues("#ddlBaseSizeType", significanceOptions.baseSizeType);
            HTMLHelpers.setSelectedValues("#ddlSigVisualizationType", significanceOptions.resultVisualization || 1);
            HTMLHelpers.setSelectedValues("#ddlSigTestHidePoints", significanceOptions.hideComparisonPoints || 0);
            HTMLHelpers.setSelectedValues("#ddlSigIconPosition", significanceOptions.iconPosition || "center");
            HTMLHelpers.setSelectedValuesOrFirst("#ddlSigStartingLetter", significanceOptions.startingLetter || "a");
			HTMLHelpers.setSelectedValues("#ddlSigSymbolsSet", significanceOptions.symbolsSet || "1");
            $('#chkShowSigValuesInTooltip').attr('checked', significanceOptions.showSigTestValuesInTooltip);
            $('#chbUseSigSymbolColors').attr('checked', significanceOptions.useColoredSymbols);

            $("#txtSigTestIconWidth").val(significanceOptions.iconWidth || 30);
            $("#txtSigTestIconHeight").val(significanceOptions.iconHeight || 30);
            $("#negativeIconContent, #positiveIconContent")
                .css("width", significanceOptions.iconWidth + "px")
                .css("height", significanceOptions.iconHeight + "px");

            $("#hidPositiveIconId").val(significanceOptions.positiveIconId || 0);
            var positiveContent = IconShapeUI.fixGUIDs(significanceOptions.positiveIconId ? significanceOptions.positiveIconContent : IconShapeUI.defaultPositiveIcon.content);
            $("#positiveIconContent").html(positiveContent).css('display', 'block');
            IconShapeUI.updateIconShapeElementSize(null, $("#positiveIconContent"));

            $("#hidNegativeIconId").val(significanceOptions.negativeIconId || 0);
            var negativeContent = IconShapeUI.fixGUIDs(significanceOptions.negativeIconId ? significanceOptions.negativeIconContent : IconShapeUI.defaultNegativeIcon.content);
            $("#negativeIconContent").html(negativeContent).css('display', 'block');
            IconShapeUI.updateIconShapeElementSize(null, $("#negativeIconContent"));

            $("#ddlDataTestType").change();
            ChartSetupUI.showHideSigTestVisualization();
            ChartSetupUI.disableSigTests();

			if (!$('#chkUseWeight').is(':checked')) {
                $('#ddlBaseSizeType').val("2");
                $('#ddlBaseSizeType').attr('disabled', 'disabled');
            }

			ChartSetupUI.configureSigTestType(dataGroup.calculationType);
        },
        SetBenchmarkOptions: function (datagroup) {
            ChartSetupUI.hideShowBenchmark();

            $('#chkEnableBenchmark').attr("checked", datagroup.benchmarkSettings.isEnabled);
            $('#ddlBenchmarkAxis').val(datagroup.benchmarkSettings.axis);
            $('#ddlBenchmarkCalculationType').val(datagroup.benchmarkSettings.calculationType);
            $('#ddlBenchmarkComparisonType').val(datagroup.benchmarkSettings.comparisonType);
            $('#ddlBenchmarkFoldingOption').val(datagroup.benchmarkSettings.foldingOption);
            $('#ddlBenchmarkPlacementOption').val(datagroup.benchmarkSettings.benchmarkPlacement);
            $('#chbShowOnlyBenchmarks').attr("checked", datagroup.benchmarkSettings.showBenchmarkOnly);
            $('#chbSortBenchmarks').attr("checked", datagroup.benchmarkSettings.sortOnBenchmark);
			$('#ddlBenchmarkSorting').val(datagroup.benchmarkSettings.sortOrder);
			if (datagroup.benchmarkSettings.pointMatchType === 1) {
				$('#ddlBenchmarkMatchBy').val(datagroup.benchmarkSettings.pointMatchType);
			} else {
				$('#ddlBenchmarkMatchBy').val(2);
				$('#ddlBenchmarkMatchByText').val(datagroup.benchmarkSettings.pointMatchType);
			}

            ChartSetupUI.enableBenchmark();
            ChartSetupUI.hideForBenchmarkOptions();
        },
        SetRankSettings: function (rankSettings) {
            if (rankSettings) {
                $('#chkEnableRanking').attr("checked", rankSettings.isEnabled);
                $('#chkShowOnlyRanking').attr("checked", rankSettings.showRankOnly);
                HTMLHelpers.setSelectedValues("#ddlRankingAxis", rankSettings.axis || "1");
                HTMLHelpers.setSelectedValues("#ddlRankObject", rankSettings.rankObject);
                $('#chkRankOnOptionalFilter').attr("checked", rankSettings.onOptionalFilter);
                HTMLHelpers.setSelectedValues("#ddlRankOptionalFilter", rankSettings.optionalFilterItem);
				HTMLHelpers.setSelectedValues("#ddlRankPosition", rankSettings.placement || "1");
				$('#chkShowRankTotalSuffix').attr('checked', rankSettings.showRankTotalSuffix);
				$('#txtRankTotalSuffix').val(rankSettings.rankTotalSuffix);
				HTMLHelpers.setSelectedValues('#ddlRankingDirection', rankSettings.direction || 1);
            }

            ChartSetupUI.enableRanking();
            ChartSetupUI.enableRankingOptionalFilter();
			ChartSetupUI.enableRankingPosition();
			ChartSetupUI.enableRankingSuffix();
		},
		SetReferenceDataSettings: function (refDataSettings) {
			$('#tblRefDataResults input.refDataResult').removeAttr('checked');
			$('#tblRefDataResults .refPercentileLabel, #tblRefDataResults .refDataResultPercentile').hide();

			$('#chbEnableReferenceData').attr('checked', refDataSettings.isEnabled);
			$('#txtRefDataPercentile').val(refDataSettings.percentile);
			HTMLHelpers.setSelectedValues('#ddlRefDataPlacement', refDataSettings.placement || "1");
			$('input.refDataResult').removeAttr('checked');
            $('input.refDataResult[value="' + refDataSettings.resultType + '"]').attr('checked', 'checked');
            $('#chbSortOnRefData').attr('checked', refDataSettings.sortOnRefData);
            $('#ddlRefDataSorting').val(refDataSettings.sortOrder || 1);
            $('#ddlRefDataSortAxis').val(refDataSettings.sortAxis || 2);

			ChartSetupUI.showHideRefDataPanel();
			ChartSetupUI.onRefDataEnabled();
			ChartSetupUI.onRefDataResultTypeChanged(refDataSettings.resultType);
			ChartSetupUI.disableRefData();
			ChartSetupUI.showHideRefDataSettings();
        },
        SetBaseInLoopedQuestionSettings: function (refDataSettings) {
            $('#chbUseLoopedResponses').attr('checked', !refDataSettings.useRespondentsForBaseInLoopedQuestion);
            $('#chbUseRespondents').attr('checked', refDataSettings.useRespondentsForBaseInLoopedQuestion);
        },
        SetChartStyles: function (styleArray, idPrefix) {
			idPrefix = idPrefix || 'chartstyle_';
			var isChartCreator = window.ContentType > 0 && window.ContentType === Storyboard.Constants.itemTypes.CHART;

            // Parses an array of styles and sets control values
            $('#misc_fixedWrappingWidth').val('0');
			
            $(styleArray).each(function (index) {
                var settingKey = this.settingKey;
				var selector = '#' + idPrefix + settingKey;
                var elem = $(selector.replace(/\./g, '_').replace('_colorPlaceholderId', ''));
				var color, colorId;

				if (window.ContentType == Storyboard.Constants.itemTypes.CHART)
					ChartCreatorSelections.SetChartCreatorStyle(this);

                if ($(elem).is('input:text') && (this.settingValue != '' || this.settingKey == 'series_pointWidth')) {
                    if ($(elem).hasClass('colorpicker-target')) {
                        // Colorpicker
                        if (~settingKey.indexOf('_colorPlaceholderId')) {
                            colorId = this.settingValue;
                            color = styleArray.filter(function (style) { return style.settingKey === settingKey.replace('_colorPlaceholderId', ''); })[0];
                            color = color ? color.settingValue : null;
                        } else {
                            colorId = styleArray.filter(function (style) { return style.settingKey === settingKey + '_colorPlaceholderId'; })[0];
                            colorId = colorId ? colorId.settingValue : null;
                            color = this.settingValue;
                        }

                        $(elem).DUIColorPicker({
                            layout: 'template',
                            selected: {
                                colorString: color,
                                templateColorId: colorId
                            }
                        });
                    } else {
                        // Textbox
                        $(elem).val(this.settingValue);
					}

					if (!isChartCreator)
						$(elem).change();
                }
                else if ($(elem).is('input:checkbox')) {
                    // Checkbox
                    $(elem).attr('checked', (this.settingValue == 'True') ? 'checked' : '');
                }
                else if ($(elem).is('input:radio')) {
                    // Radiobutton
                    $(elem).attr('checked', (this.settingValue == 'True') ? 'checked' : '');
                }
                else if (($(elem).is('select') || $(elem).is('input:hidden')) && this.settingValue != '' && this.settingValue != null) {
                    // Dropdownlist or hidden field
                    if (this.settingValue.includes(",") && this.settingKey === "chart_style_fontFamily") {
                        var sv = this.settingValue.split(',')[0];
                        $(elem).val(sv);
                    }
                    else {
                        $(elem).val(this.settingValue);
                    }
					
					if (!isChartCreator)
						$(elem).trigger('change');
                } else if ($(elem).is('div.DUIButtonsGroupVertical')) {
					$(elem).find('button').removeClass('active');
					$(elem).find('button[value="' + this.settingValue + '"]').addClass('active');
				} else if ($(elem).is('div') && this.settingValue != '') {
                    this.settingValue = (this.settingValue == "null") ? "Solid" : this.settingValue;
                    if ($(elem).hasClass('ChartStyleDashStyle')) {
						$(elem).children('.ChartStyleDashStyleValue').attr('data-value', this.settingValue);
						$(elem).children('.ChartStyleDashStyleValue').css('background-image', "url('images/chart_descriptions/" + this.settingValue + ".png')");
                    }
                }
            });

			ChartSetupUI.showHideLabelPosition();
			ChartSetupUI.showHideDataLabelPadding();
        },
        OverrideSpecificThemeStyles: function (styles) {
            var seriesType = $('#ddlSeriesType').val();

            styles.forEach(function (style) {
                if (seriesType == Storyboard.Constants.SeriesTypes.HEATMAP) {
                    if (style.settingKey == 'series_dataLabels_align')
                        style.settingValue = "center";
                }
            });
        },
        SetFormatRules: function (formatRules) {
            if (formatRules && formatRules.length > 0)
                $("#formatRulesIds").val(formatRules.join(','));
            else
                $("#formatRulesIds").val("");
        },
        SetTopValuesPerGroupNames: function (names, showTopValuesPerGroup) {
            var tableId = "tblShowTopValuePerGroupNames", rowTemplateClass = "serieNameTemplate";
            $("#" + tableId + " > tbody > .serieNameRow:not('." + rowTemplateClass + "')").remove();

            if (showTopValuesPerGroup > 0) {
                var rowTemplate = $("." + rowTemplateClass);
                rowTemplate.show();

                $(names).each(function () {
                    var newRow = rowTemplate.clone();
                    newRow.removeClass(rowTemplateClass);
                    $("#" + tableId + " > tbody:last").append(newRow);
                    newRow.find("label").text(newRow.index());
                    newRow.find("input").val(this);
                });

                rowTemplate.hide();
            }
        },
        SetGradientStops: function (gradientStops) {
            var tableId = "tblHeatMapGradient", rowTemplateClass = "heatmapGradientTemplate", deleteBtnId = "btnDeleteGradientStop";
            $("#" + tableId + " > tbody > .heatmapGradientRow:not('." + rowTemplateClass + "')").remove();

            $(gradientStops).each(function () {
                var newRow = ChartSetupUI.addRowFromTemplate(tableId, rowTemplateClass);

                newRow.find("#txtGradientStop").val(this.stopValue);

                var colorTxt = newRow.find("#clGradientColor");
                colorTxt.val(this.color);
                colorTxt.css('background', '');
                var value = (this.color.toLowerCase().replace(/ /g, '').indexOf('(255,255,255,0') > -1) ? 'transparent' : this.color;
                colorTxt.css('background-color', value);
                colorTxt.attr('title', value);
                colorTxt.change();

                newRow.find("#" + deleteBtnId).bind("click", function () {
                    ChartSetupUI.removeRow(this, 'heatmapGradientRow');
                });
            });
        },
        SetTargetAreas: function (targetAreas) {
            var taTableId = "targetAreasTable", taRowTemplateClass = "targetAreaTemplate";

            // remove all target area rows except for template
            $("#" + taTableId + " > tbody > .targetAreaRow:not('." + taRowTemplateClass + "')").remove();
            var targetAreaTemplate = $("." + taRowTemplateClass);
            targetAreaTemplate.show();
            $(targetAreas).each(function () {
                var newRow = targetAreaTemplate.clone();
                newRow.removeClass(taRowTemplateClass);

                newRow.find('#txtStartValue').val(this.startValue);
                newRow.find('#txtStopValue').val(this.stopValue);

                var colorTxt = newRow.find(".ColorTextboxTemplate");
                colorTxt.addClass("ColorTextbox").removeClass("ColorTextboxTemplate");
                colorTxt
                    .DUIColorPicker({
                        layout: 'template',
                        selected: {
                            colorString: this.color,
                            templateColorId: this.color_colorPlaceholderId
                        }
                    });

                newRow.find("#btnDeleteTargetArea").bind("click", function () {
                    ChartSetupUI.removeRow(this, "targetAreaRow");
                });

                $("#" + taTableId + " > tbody:last").append(newRow);
            });

            targetAreaTemplate.hide();
        },
        SetTableLayoutSettings: function (dataGroup) {
            if (!dataGroup.tableLayoutSettings) {
                if (dataGroup.version < 8) // before version 8 Use full height is Off by default
                    $("#chbUseFullHeight").attr("checked", false);
                return;
            }

            $("#chbUseFullWidth").attr("checked", dataGroup.tableLayoutSettings.useFullWidth);
            $("#chbUseFullHeight").attr("checked", dataGroup.tableLayoutSettings.useFullHeight);
        },
        SetScatterMeanSettings: function (scatterMeanOptions) {
            Helpers.fixDotnetCasing(scatterMeanOptions);

            $('#chbScatterMeanConsiderBase').attr('checked', scatterMeanOptions ? scatterMeanOptions.considerBase : false);
            // mean lines
            $('#chbScatterMeanLines').attr('checked', scatterMeanOptions ? scatterMeanOptions.showMeanLines : false);
            var meanLineColor = scatterMeanOptions && scatterMeanOptions.meanLineColor ? scatterMeanOptions.meanLineColor : '#7F7F7F';
            $("#txtScatterMeanLineColor").DUIColorPicker({
                layout: 'template',
                selected: {
                    colorString: meanLineColor,
                    templateColorId: scatterMeanOptions ? scatterMeanOptions.meanLineColor_colorPlaceholderId : ""
                }
            });
            HTMLHelpers.setSelectedValues('#ddlScatterMeanLineWidth', scatterMeanOptions ? scatterMeanOptions.meanLineWidth : "2");
            var lineStyle = scatterMeanOptions ? scatterMeanOptions.meanLineStyle : 'ShortDot';
            $('#divScatterMeanLineStyle').children('.ChartStyleDashStyleValue').attr('data-value', lineStyle);
            $('#divScatterMeanLineStyle').children('.ChartStyleDashStyleValue').css('background-image', "url('images/chart_descriptions/" + lineStyle + ".png')");

            function setColorBoxSelection(box, color, cpId) {
                $(box).DUIColorPicker({
                    layout: 'template',
                    selected: {
                        colorString: color,
                        templateColorId: cpId
                    }
                });
            }

            // mean quadrants            
            $('#chbScatterMeanQuadrants').attr('checked', scatterMeanOptions ? scatterMeanOptions.showMeanQuadrants : false);
            var topLeftQColor = scatterMeanOptions && scatterMeanOptions.topLeftQuadrantColor ? scatterMeanOptions.topLeftQuadrantColor : '#FCD5B6';
            setColorBoxSelection("#txtScatterMeanTopLeftColor", topLeftQColor, scatterMeanOptions ? scatterMeanOptions.topLeftQuadrantColor_colorPlaceholderId : "");
            var topRightQColor = scatterMeanOptions && scatterMeanOptions.topRightQuadrantColor ? scatterMeanOptions.topRightQuadrantColor : '#D7E3BD';
            setColorBoxSelection("#txtScatterMeanTopRightColor", topRightQColor, scatterMeanOptions ? scatterMeanOptions.topRightQuadrantColor_colorPlaceholderId : "");
            var bottomLeftQColor = scatterMeanOptions && scatterMeanOptions.bottomLeftQuadrantColor ? scatterMeanOptions.bottomLeftQuadrantColor : '#DA9695';
            setColorBoxSelection("#txtScatterMeanBottomLeftColor", bottomLeftQColor, scatterMeanOptions ? scatterMeanOptions.bottomLeftQuadrantColor_colorPlaceholderId : "");
            var bottomRightQColor = scatterMeanOptions && scatterMeanOptions.bottomRightQuadrantColor ? scatterMeanOptions.bottomRightQuadrantColor : '#FCD5B6';
            setColorBoxSelection("#txtScatterMeanBottomRightColor", bottomRightQColor, scatterMeanOptions ? scatterMeanOptions.bottomRightQuadrantColor_colorPlaceholderId : "");

            // points colored by quadrant belonging
            var topLeftPColor = scatterMeanOptions && scatterMeanOptions.topLeftPointColor ? scatterMeanOptions.topLeftPointColor : '#FCD5B6';
            setColorBoxSelection("#txtScatterPointTopLeftColor", topLeftPColor, scatterMeanOptions ? scatterMeanOptions.topLeftPointColor_colorPlaceholderId : "");
            var topRightPColor = scatterMeanOptions && scatterMeanOptions.topRightPointColor ? scatterMeanOptions.topRightPointColor : '#D7E3BD';
            setColorBoxSelection("#txtScatterPointTopRightColor", topRightPColor, scatterMeanOptions ? scatterMeanOptions.topRightPointColor_colorPlaceholderId : "");
            var bottomLeftPColor = scatterMeanOptions && scatterMeanOptions.bottomLeftPointColor ? scatterMeanOptions.bottomLeftPointColor : '#DA9695';
            setColorBoxSelection("#txtScatterPointBottomLeftColor", bottomLeftPColor, scatterMeanOptions ? scatterMeanOptions.bottomLeftPointColor_colorPlaceholderId : "");
            var bottomRightPColor = scatterMeanOptions && scatterMeanOptions.bottomRightPointColor ? scatterMeanOptions.bottomRightPointColor : '#FCD5B6';
            setColorBoxSelection("#txtScatterPointBottomRightColor", bottomRightPColor, scatterMeanOptions ? scatterMeanOptions.bottomRightPointColor_colorPlaceholderId : "");

            ChartSetupUI.showHideScatterMeanLineSettings();
            ChartSetupUI.showHideScatterMeanQuadrantSettings();
		},
        ShowHideFilterPanel: function (array, panel, checkbox) {
            if (array.length > 0) {
                $(panel).css("display", "inherit");
                $(checkbox).attr("checked", true);
            }
            else {
                $(panel).css("display", "none");
                $(checkbox).attr("checked", false);
            }
        },
        ElementSort: function (a, b) {
            if (a.sortOrder < b.sortOrder)
                return -1;
            else if (a.sortOrder === b.sortOrder)
                return 0;
            else
                return +1;
        },
		HideGuiElementsByType: function (seriesType, dataGroup, contentType) {
            unwrapAll();

            if (HeatMapQuickSetup.isLoaded == true && contentType != Storyboard.Constants.itemTypes.HEATMAP)
                HeatMapQuickSetup.destroy();

            //basic hiding and showing of elements depending on whether or not this is the main data group
			var subSeriesShow = ['.hdMatchXAxisText', '.hdUseSecondaryAxis',
				'#divUseMainGroupsOptFilters', '.machSeriesText', '.useMainFormatRules',
				'.hdTrimLowBaseByMain', '.hdTrimLowResultByMain', '.hdWarnLowBaseByMain'];
            var subSeriesHide = [
                '.hdLegendPos',
                //'.hdTrimCompare',
                '.hdAxisText > span:not(.positivePrefix)',
                '.hdAxisScale',
                '.hdToolTips',
                '.additionalChart',
                '.baseSizePosition',
                '.additionalToolTip',
                '.InvertChartWrapper',
                '.hdPolarWrapper',
                '.hdTargetAreas',
                //'.hdWarnLowBase',
                //'.hideLowResultContainer',
                '.baseSizeInfo',
                '.objectExcelExport',
				'.objectExcelExportAllRows',
				'#sigShowValuesInTooltip'
            ];
			var alwaysShow = [
				'.hdIntervals',
                '#divAxisTexts .settingItem',
                '.axisScalesWrapper',
                '.hdGroupings',
                ".hdTopValuesPerGroup",
                '.hdShowTexts',
                '.YAxisWrapper',
                '#hdSeriesSettings',
                '.ColorLogicWrapper',
                '.SeriesOptionWrapper',
                '.SeriesTypeWrapper',
                '.hdAxisOptions',
                '.AxisValuesShowWrapper',
                '.hdTopXSeries',
                '#tabChartLayout',
                '#hdAxisSettings',
                '#hdChartSettings',
                '.hdStatistics',
				'.hdMeanValueSeries',
				'.hdAggregatedSeries',
                '.hdPosNeg',
                '.hideLowBaseContainer',
                '.warnLowBaseContainer',
                '.ShowFilterInfoWrapper',
                '#ddlCalculationType',
                '#qbFilterPanelWrapper',
                '#fsQnAnsFiltering',
                '#hFilterSettingPanel',
                '.settingItem.XAxisWrapper',
                'label[for="ddlSeriesOptions"]',
                '#ddlSeriesOptions',
                'label[for="cbShowFilterTexts"]',
                '#cbShowFilterTexts',
                'label[for="cbShowTimeIntervalTexts"]',
                '#cbShowTimeIntervalTexts',
                'label[for="chbTrimCompareSeries"]',
                '#chbTrimCompareSeries',
                'label[for="ddlColorLogic"]',
                '#ddlColorLogic',
                '#tabChartAnalysis',
				'.hdOther',
                '.generateDecimalsWrapper'
            ];
            var alwaysHide = [
                '#tabSpecialSettings',
                '#specialSettings',
                '#scatterAxes',
                '#tabTableLayout',
                '#tableBenchmarkPlacement',
                '#sigPlacementOptionLabel',
                '#ddlSigPlacementOption',
                '#GaugeSettings',
                '.hdFormattingRules',
                '#divHeatMapLegend',
                '#moveToHeatMapLegendBtns',
                '#hdHeatmapSettings',
                '#heatMapLegendGroup',
                '.tableAsScreenshot',
                '.tableBaseSize',
                '#rankPanel',
                '.hdCustomHeaders',
                '.sortByColumns',
                '.SeriesLayoutWrapper',
                '#dynamicColorsDiv',
                '.chartStyleSeriesBorder',
                '.chartStyleSeriesBorderColor',
                '.chartStyleSeriesBorderWidth',
				'.chartStyleSeriesShadow',
				'#fsSearchBgColor',
                '#trRefPercentileRanking',
                '#hdTableHeatMap'
            ];

            $(subSeriesHide.join(',')).toggle(dataGroup.isMain);
            $(subSeriesShow.join(',')).toggle(!dataGroup.isMain);
            $(alwaysShow.join(',')).show();
			$(alwaysHide.join(',')).hide();

            if (window.IsDrilldown) {
                ChartSetupUI.hideHFilterPanel(false);
                $('#optionFilterSettingPanel, #hOptFiltersBehavior').hide();
                $('#selectDefaultPlacementFilters').closest('.settingItem').hide();
            }
            else {
                ChartSetupUI.hideHFilterPanel(Storyboard.HFilterLayout.hasHFilterNodes());
            }

			$('.refDataResultPercentile, .refPercentileLabel').toggle(ProjectHasRefData);

            //reset some texts that can be set to something else below
            $('#divAxisLegendTitle').text(locale.get("Axis and Legend")).parent().removeClass().addClass('settingsFieldset hdGroupings chartGroupings');
            $('#hAxisTitle').text(locale.get("Axis"));
            $('#hLegendTitle').text(locale.get("Legend"));

            $('#lblTopValuePerGroup').text(locale.get('Values per axis group'));

            $('#lblYAxisUnit').text(locale.get('Unit'));
            $('#lblXAxisText').text(locale.get('X-Axis text'));

            $('#chbShowAxisLabel + label').text('Axis label');
            $('#chbShowLegendLabel + label').text('Legend label');

			$('#ddlShowTopSeriesMode option[value=1], #ddlMeanValueOrientation option[value=1], ' +
				'#ddlAggrSeriesOrientation option[value = 1], #selectDefaultPlacementFilters option[value = 2]').text(locale.get('Axis'));
			$('#ddlShowTopSeriesMode option[value=2], #ddlMeanValueOrientation option[value=2], ' +
				'#ddlAggrSeriesOrientation option[value = 2], #selectDefaultPlacementFilters option[value=1]').text(locale.get('Legend'));

            $('#ddlDataCompareType option[value=2]').text(locale.get('Axis groups'));
            $('#ddlDataCompareType option[value=1]').text(locale.get('Legend items'));

            $("input.seriesTrimming").removeAttr("disabled");

            ChartSetupUI.disableForSeriesOptions(dataGroup.seriesSettings.seriesAttribute);
            ChartSetupUI.disableRespCountTooltip();
            ChartSetupUI.showHideDataLabelPadding();

            if ($("#ddlDateVar option").length <= 1)
                $(".hdDateVar").hide();
            else
                $(".hdDateVar").show();

            $(".sigResultToShow").toggle($("#ddlAnalysisType").val() == "2" || $("#ddlDataTestType").val() == "1");
            $("#optHFilterContainer").toggle(Storyboard.HFilterLayout.hasHFilterNodes() || false);
            $("#cbShowThousandSeparator").closest("tr").toggle(contentType == Storyboard.Constants.itemTypes.SIMPLETABLE);
            $('#lblRunTopSeriesAfterOp').text('Benchmark operations');

            var heatmapStuff = $("#dynamicColorsDiv").detach();
            if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE) {
                $(".hdTableHeatmapOptions").append(heatmapStuff);
            } else {
                $("#hdSeriesSettings .settingItem.ColorLogicWrapper").after(heatmapStuff);
			}

            if (contentType == Storyboard.Constants.itemTypes.SIMPLETABLE) {

                $('#settings .settingsFieldset').removeClass('collapsable').addClass('expandable');
                $('#hdChartSettings').removeClass('settingsFieldset').css('display', 'none');
                $('.settingsGroup.noOfDecimals').removeClass('settingsGroup').addClass('settingsFieldsetContent expandableContent').insertAfter($('#spanSerieTrimOptions .settingsFieldsetLegend'));
                $('#spanSerieTrimOptions').removeClass('expandable').addClass('collapsable').find(' > .settingsFieldsetLegend > span').text('Table');
                $('#hdAxisSettings > .settingsFieldsetLegend > span').text('Text');
                $('#hdAxisSettings h3').hide();
                $('#hdDefaultSettings > h3').text('Default behavior in Optional filters & Text settings');
                $('#lblRunTopSeriesAfterOp').text('Rank and Benchmark operations');

                $('#hdTableHeatMap').show();
                $('#ddlColorValueSourceLabel').hide();
                $('#ddlColorValueSource').hide();
                $('#txtGradientMinValue').closest('span').hide();
                $('#txtGradientMaxValue').closest('span').hide();

				//if (has ref data with percentiles)
				$('#trRefPercentileRanking').toggle(ProjectHasPercentileRefData);

                $(['#divAxisTexts .settingItem',
                    '.axisScalesWrapper',
                    '.hdUseSecondaryAxis',
                    '.AxisValuesShowWrapper',
                    '.SeriesTypeWrapper',
                    '.SeriesOptionWrapper',
                    '.ColorLogicWrapper',
                    '.hdLegendPos',
                    '.additionalToolTip',
                    '.hdToolTips',
                    '.additionalChart',
                    '.baseSizePosition',
                    '#tabChartLayout',
                    '.hdMatchXAxisText',
                    '.hdDetailTable',
                    '.hdPolarWrapper',
                    '.InvertChartWrapper',
                    '.hdTargetAreas',
					'.hdTopValuesPerGroup',
					'.generateDecimalsWrapper',
					'#sigShowValuesInTooltip'
                ].join(',')).hide();

                $(['.hdAxisText',
                    '#divAxisTexts .cf',
                    '#divAxisTexts .positivePrefix',
                    '#tabTableLayout',
                    '#tableBenchmarkPlacement',
                    '#sigPlacementOptionLabel',
                    '#ddlSigPlacementOption',
                    '.baseSizeInfo',
                    '#rankPanel',
                    '.hdCustomHeaders'
                ].join(',')).show();

                if (dataGroup.isMain)
                    $('.sortByColumns').show();

                $('.hdFormattingRules').show();

                $('#divAxisLegendTitle').text("Rows and Columns").parent().removeClass().addClass('settingsFieldset hdGroupings tableGroupings');
                $('#hAxisTitle').text("Rows");
                $('#hLegendTitle').text("Columns");

                $('#ddlShowTopSeriesMode option[value=1],' +
					'#ddlMeanValueOrientation option[value=1],' +
					'#ddlAggrSeriesOrientation option[value=1],' +
                    '#selectDefaultPlacementFilters option[value=2],' +
					'#ddlDataCompareType option[value=2],' +
                    '#ddlBenchmarkMatchByText option[value=2],' +
                    '#ddlRefDataSortAxis option[value=2]').text(locale.get('Rows'));
                $('#ddlShowTopSeriesMode option[value=2],' +
					'#ddlMeanValueOrientation option[value=2],' +
					'#ddlAggrSeriesOrientation option[value=2],' +
                    '#selectDefaultPlacementFilters option[value=1],' +
					'#ddlDataCompareType option[value=1],' +
                    '#ddlBenchmarkMatchByText option[value=3],' +
                    '#ddlRefDataSortAxis option[value=1]').text(locale.get('Columns'));

                $('#percentilePanel').hide();
                $('#thresholdPanel').hide();
            }
            else if (contentType == Storyboard.Constants.itemTypes.HEATMAP) {

                $(['#hdChartSettings',
                    '#tabChartAnalysis',
                    '.hdToolTips',
                    '.hdOther',
                    '.hdGroupings',
                    '#tabChartLayout',
                    '#thresholdPanel'
                ].join(',')).hide();

                $('.hdAxisOptions').toggle(dataGroup.isMain);

                $('#ddlShowTopSeriesMode option[value=1]').text('X Axis');
                $('#ddlShowTopSeriesMode option[value=2]').text('Y Axis');
                $('#lblTopValuePerGroup').text('Values per Y axis group');

                $(['#divHeatMapLegend',
                    '#moveToHeatMapLegendBtns',
                    '#hdHeatmapSettings',
                    '#heatMapLegendGroup'
                ].join(',')).show();

                $('#divAxisLegendTitle').parent().removeClass().addClass('settingsFieldset hdGroupings heatmapGroupings');
                $('#hAxisTitle').text("X Axis");
                $('#hLegendTitle').text("Y Axis");

                HeatMapQuickSetup.init();
            }
            else { // CHART
                $('.machSeriesText').hide();
                $('#percentilePanel').show();
                $('#thresholdPanel').show();
                $('#settings .settingsFieldset').removeClass('collapsable').addClass('expandable');
                $('#hdChartSettings').removeClass('expandable').addClass('settingsFieldset collapsable').css('display', 'block').find('> .settingsFieldsetLegend > span').text('Chart');
                $('.settingsFieldsetContent.noOfDecimals').removeClass('settingsFieldsetContent expandableContent').addClass('settingsGroup').appendTo($('#hdSeriesSettings'));
                $('#spanSerieTrimOptions > .settingsFieldsetLegend > span').text('Series');
                $('#hdAxisSettings > .settingsFieldsetLegend > span').text('Axis and text');
                $('#hdDefaultSettings > h3').text('Default behavior in Optional filters & Chart settings');
                $('#ddlColorLogic').removeAttr('disabled');
                ChartSetupUI.disableRespCountTooltip();
                ChartSetupUI.disableMeanSeriesColor();
                $('#chbShowAxisLabel').closest('.settingItem').show();

                // undo setting changes done by Treemap and Heatmap
                if (dataGroup.isMain) {
                    $('#btnCreateDataGroup').show();
                    $('#btnEditSeries').show();
                    $('#ddlAxisSort').parent().show();
                    $('#ddlLegendSort').parent().show();
                    $('#chkInvertChart').closest('.settingsGroup').show();
                    $('#chkInvertChart').closest('.settingItem').show();
                    showOption($('#ddlLegendPosition'), Storyboard.Constants.LegendPosition.DataLabel);
                    $('#cbShowValues').removeAttr('disabled');
                    $('.hdLegendPos').show();
                    hideOption($('#ddlColorLogic'), Storyboard.Constants.ColorSources.DYNAMIC_COLORS);
                    $('#ddlBasePosition option').each(function () {
                        if ($(this).val() == Storyboard.Constants.BaseSizePosition.Axis)
                            $(this).text('Axis');
                        else if ($(this).val() == Storyboard.Constants.BaseSizePosition.Legend)
                            $(this).text('Legend');
                        else if ($(this).val() == Storyboard.Constants.BaseSizePosition.Series)
                            $(this).text('Series');
                    });
                    $('#ddlShowTopSeriesMode option').each(function () {
                        if ($(this).val() == 1)
                            $(this).text('Axis');
                        else if ($(this).val() == 2)
                            $(this).text('Legend');
                    });
                    $('#ddlBenchmarkAxis option').each(function () {
                        if ($(this).val() == Storyboard.Constants.BenchmarkDimension.Legend)
                            $(this).text('Legend');
                        else if ($(this).val() == Storyboard.Constants.BenchmarkDimension.Axis)
                            $(this).text('Axis');
					});
					$('#ddlBenchmarkMatchByText option').each(function () {
						if ($(this).val() == 2)
							$(this).text('Axis');
						else if ($(this).val() == 3)
							$(this).text('Legend');
                    });
                    $('#ddlRefDataSortAxis option').each(function () {
                        if ($(this).val() == 1)
                            $(this).text('Legend');
                        else if ($(this).val() == 2)
                            $(this).text('Axis');
                    });
                    $('#chbTrimDates').closest('.settingsFieldsetContent').show();
                    $('.hdTrimDateGaps').show();
                    $('.hdTrimEmpty').show();
                    $('#chbShowTopValuesPerGroup').closest('.hdTopValuesPerGroup').show();
                    $('#chbTrimCompareSeries').closest('.settingItem').show();
                    $('#txtXAxis').closest('.settingItem').show();
                    $('#txtYAxis').closest('.settingItem').show();
                    $('#chbShowUnitOnYAxis').closest('span').show();
                    $('#chbShowSeparatorOnYAxis').closest('span').show();
                    $('.axisScalesWrapper').show();
                    $('#lblXAxisText').text('X-Axis text');
                    $('#lblYAxisText').text('Y-Axis text');
                    $('#ddlDataCompareType option').each(function () {
                        if ($(this).val() == Storyboard.Constants.ZTestBetween.LegendItems)
                            $(this).text('Legend Items');
                        else if ($(this).val() == Storyboard.Constants.ZTestBetween.AxisGroups)
                            $(this).text('Axis Groups');
                    });
                    $('#ddlMeanValueOrientation option').each(function () {
                        if ($(this).val() == Storyboard.Constants.MeanValueOrientation.Legend)
                            $(this).text('Legend');
                        else if ($(this).val() == Storyboard.Constants.MeanValueOrientation.Axis)
                            $(this).text('Axis');
                    });
                    $('#layout').find('.chartStyleLegendSettings').show();
                    $('#layout .chartStyleAxisSettings > .settingsFieldsetContent').not('.chartStyleAxisSettingsFilterInformation').show();
                    $('#chartstyle_chart_plotBackgroundColor').closest('.settingsFieldsetContent').show();
                    $('#chartstyle_xAxis_gridLineColor').closest('.settingsFieldsetContent').show();
                    $('#chartstyle_xAxis_lineColor').closest('.settingsFieldsetContent').find('h3').text(locale.get('Serie-axis line'));
                    $('#chartstyle_xAxis_labels_style_width').show();
                    $('#chartstyle_yAxis_lineColor').closest('.settingsFieldsetContent').find('h3').text(locale.get('Value-axis line'));
                    $('#chartstyle_yAxis_misc_showLastLabel').closest('.settingItem').show();
                    $('#chartstyle_xAxis_title_style_color').closest('.settingsFieldsetContent').find('h3').text(locale.get('Serie-axis information text'));
                    $('#chartstyle_yAxis_title_style_color').closest('.settingsFieldsetContent').find('h3').text(locale.get('Value-axis information text'));
                }
                var st = Storyboard.Constants.SeriesTypes;

                if (seriesType == st.LINE || seriesType == st.SPLINE) {
                    $('#startPercentile').attr('disabled', 'disabled');
                }
                else {
                    $('#startPercentile').removeAttr('disabled');
                }

                if (seriesType == st.PIE || seriesType == st.DONUT || seriesType == st.BUBBLE ||
					seriesType == st.SCATTER || seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE
                    || seriesType == st.HEATMAP) {
                    dataGroup.usePercentile = false;
                    $('#chkPercentile').removeAttr('checked');
                    $('#chkPercentile').attr('disabled', true);
                    $('#percentilePanel').hide();
                }
                else {
                    $('#chkPercentile').removeAttr('disabled');
                    $('#percentilePanel').show();
                }

                $('#chartstyle_series_marker_enabled').closest('tr').toggle(Storyboard.Constants.SeriesTypes.isLineOrAreaBased(seriesType));

                if (seriesType == st.DONUT) {
                    $("#GaugeSettings, .innerRadiusWrapper").show();
                    $("#gaugeStyleSettingsLabel").text("Donut");
                    $(".gaugeOnlyStyle").hide();
                }

                if (seriesType == st.LINE || seriesType == st.SPLINE || seriesType == st.AREA ||
                    seriesType == st.VERTICALLINE || seriesType == st.VERTICALSPLINE || seriesType == 12) {
                    $('#chartstyle_series_lineWidth').closest('.settingsFieldsetContent').show();
                }
                else {
                    $('#chartstyle_series_lineWidth').closest('.settingsFieldsetContent').hide();
                }

                if (seriesType == st.LINE || seriesType == st.SPLINE || seriesType == st.AREA || seriesType == st.VERTICALAREA ||
                    seriesType == st.VERTICALLINE || seriesType == st.VERTICALSPLINE || seriesType == st.SCATTER
                    || seriesType == st.BUBBLE || seriesType == st.HEATMAP) {
                    $('#valueBasedColorsDiv').hide();
                    hideOption($('#ddlColorLogic'), Storyboard.Constants.ColorSources.VALUE_BASED);
                    if ($("#ddlColorLogic").val() == Storyboard.Constants.ColorSources.VALUE_BASED)
                        $("#ddlColorLogic").val(Storyboard.Constants.ColorSources.QUESTION);

                }
                else {
                    showOption($('#ddlColorLogic'), Storyboard.Constants.ColorSources.VALUE_BASED);
                    if ($("#ddlColorLogic").val() == Storyboard.Constants.ColorSources.VALUE_BASED)
                        $('#valueBasedColorsDiv').show();
                }
                $('.hdDetailTable').toggle(dataGroup.isMain && $('#lbDetailTables > option').length > 1);

				if (st.canUseSeriesBorder(seriesType)) {
					$('.chartStyleSeriesBorder', '#setupChart').show();
					$('.chartStyleSeriesBorderColor, .chartStyleSeriesBorderWidth', '#setupChart').show();
				}

				if (st.canUseSeriesShadow(seriesType)) {
					$('.chartStyleSeriesBorder', '#setupChart').show();
					$('.chartStyleSeriesShadow', '#setupChart').show();
                }
                $('#chartstyle_yAxis_gridLineColor').closest('.settingsGroup').show();

                //below: hide items on special conditions like series types etc. Any thing you hide here most be included in the logic above so it
                //will be re-enabled when another series type is selected.
                if (seriesType == st.SCATTER || seriesType == st.BUBBLE) {
                    $(['.hdIntervals',
                    '.hdShowTexts',
                    '.hdGroupings',
                    '.hdTrimDateGaps',
                    '.hdTrimNoDataSeries',
                    '.hdTrimEmpty',
                    '.hdMatchXAxisText',
                    '.YAxisWrapper',
                    '.hdUseSecondaryAxis',
                    '.ColorLogicWrapper',
                    '.SeriesOptionWrapper',
                    '.hdStatistics',
                    '.additionalChart',
                    '#hFilterSettingPanel',
                    '.hdTargetAreas',
                    '.hideLowResultContainer',
                    '#thresholdPanel'
                    ].join(',')).hide();

                    $('.hdTopXSeries').closest('.settingsFieldsetContent').hide();
                    $('#chbShowAxisLabel').closest('.settingItem').hide();

                    $("input.seriesTrimming[id!='chbShowTopValuesPerGroup']").attr("disabled", "disabled");
                    $('#chbTrimLowBase').removeAttr("disabled");
                    $('#chbWarnLowBase').removeAttr("disabled");

                    $("#tabSpecialSettings, #specialSettings").show();
                    $('#hdSeriesSettings, .hdLegendPos').toggle(dataGroup.isMain);

                    $('#lblYAxisUnit').text(locale.get('Unit'));
                    $('#lblXAxisText').text(dataGroup.isMain ? locale.get('X-Axis text') : locale.get('Y-Axis text'));

                    //hack for 'z' group, hide some more options
                    if (dataGroup.index == 2) {
                        $('#hdAxisSettings, #hdChartSettings').hide();
                    }
                }
                else if (seriesType == st.PIE || seriesType == st.DONUT) {
                    $(['.hdTargetAreas',
                    '.hdPolarWrapper',
                    '.hdMeanValueSeries',
                    '.hdStatistics'
                    ].join(',')).hide();
                }
                else if (seriesType == st.GAUGE || seriesType == st.SOLIDGAUGE) {
                    $(['.hdPolarWrapper',
                    '.InvertChartWrapper',
                    '.hdGroupings',
                    '.hdStatistics',
                    '#chartstyle_series_marker_symbol',
                    '.settingItem.XAxisWrapper',
                    '#SeriesOptionWrapper',
                    '.innerRadiusWrapper'
                    ].join(',')).hide();

                    $(['#GaugeSettings',
                        ".gaugeOnlyStyle"
                    ].join(',')).show();
                    $("#gaugeStyleSettingsLabel").text("Gauge");

                    $('.hdMeanValueSeries').show();
                    $('.SeriesOptionWrapper:not(.hdLegendPos), .innerRadiusWrapper').toggle(seriesType == st.SOLIDGAUGE);

                    // force dataLabels align to center
                    ChartSetupUI.disableForSeriesOptions(1);
                } else if (seriesType == st.FUNNEL) {
                    // Layout tab
                    $('#chartstyle_yAxis_gridLineColor').closest('.settingsGroup').hide();
                    $('#chartstyle_yAxis_lineColor').closest('.settingsFieldsetContent').hide();
                    $('#chartstyle_yAxis_title_style_color').closest('.settingsFieldsetContent').hide();

                    $('#chkInvertChart').closest('.settingItem').hide();
                    $('#chbTransformIntoPolar').closest('.settingItem').hide();
                } else if (dataGroup.isMain) {
                    if (seriesType == st.TREEMAP) {
                        $('#btnCreateDataGroup').hide();
                        $('#btnEditSeries').hide();

                        // Variables tab
                        $('#ddlAxisSort').parent().hide();
                        $('#ddlLegendSort').parent().hide();

                        $('#divAxisLegendTitle').text('Levels').parent().removeClass().addClass('settingsFieldset hdGroupings treemapGroupings');
                        $('#hAxisTitle').text('Level 1');
                        $('#hLegendTitle').text('Level 2');

                        // Settings -> Chart
                        $('#ddlSeriesOptions').val(2); // Full stacked - default Treemap series option
                        $('#ddlSeriesLayoutOptions').val(3); // Squarifed - default Treemap series layout
                        $('.SeriesLayoutWrapper').show();
                        hideOption($('#ddlSeriesOptions'), Storyboard.Constants.SeriesOptions.SideBySide);
                        $('#chkInvertChart').closest('.settingItem').hide();
                        $('#chbTransformIntoPolar').closest('.settingItem').hide();
                        $('#chartZooming').closest('.settingItem').hide();
                        hideOption($('#ddlLegendPosition'), Storyboard.Constants.LegendPosition.DataLabel);
                        $('#ddlShowBase').closest('.settingItem').hide();
                        showOption($('#ddlColorLogic'), Storyboard.Constants.ColorSources.DYNAMIC_COLORS);
                        if ($('#ddlColorLogic').val() == Storyboard.Constants.ColorSources.DYNAMIC_COLORS)
                            $('#dynamicColorsDiv').show();

                        if ($('#ddlColorLogic').val() != Storyboard.Constants.ColorSources.DYNAMIC_COLORS)
                            $('.hdLegendPos').hide();

                        // Settings -> Series
                        $('#chbTrimDates').closest('.settingsFieldsetContent').hide();
                        $('#chbShowTopValuesPerGroup').closest('.hdTopValuesPerGroup').hide();
                        $('#chbTrimCompareSeries').closest('.settingItem').hide();
                        $('#thresholdPanel').hide();
                        $('#ddlColorValueSourceLabel').show();
                        $('#ddlColorValueSource').show();

                        // Settings -> Axis and Text
                        $('#txtXAxis').closest('.settingItem').hide();
                        $('#txtYAxis').closest('.settingItem').hide();
                        $('#chbShowUnitOnYAxis').closest('span').hide();
                        $('#chbShowSeparatorOnYAxis').closest('span').hide();
                        $('.axisScalesWrapper').hide();

                        // Settings -> Tooltip
                        $('#chbShowAxisLabel + label').text('Level 1 label');
                        $('#chbShowLegendLabel + label').text('Level 2 label');

                        // Settings -> Other
                        $('.hdTargetAreas').hide();
                        $('#selectDefaultPlacementFilters option[value=1]').text(locale.get('Level 2'));
                        $('#selectDefaultPlacementFilters option[value=2]').text(locale.get('Level 1'));

                        // Analysis tab
                        $('#tabChartAnalysis').hide();

                        // Layout tab
                        $('#chartstyle_xAxis_gridLineColor').closest('.settingsFieldsetContent').hide();
                        $('#layout .chartStyleLegendSettings').hide();
                        $('#layout .chartStyleAxisSettings > .settingsFieldsetContent').not('.chartStyleAxisSettingsFilterInformation').hide();

                        // Layout tab -> Grid Area
                        $('#chartstyle_chart_plotBackgroundColor').closest('.settingsFieldsetContent').hide();
                    } else if (seriesType == st.HEATMAP) {
                        $('#btnCreateDataGroup').hide();
                        $('#btnEditSeries').hide();

                        // Variables tab
                        $('#divAxisLegendTitle').text('Rows and Columns').parent().removeClass().addClass('settingsFieldset hdGroupings heatmapGroupings');
                        $('#hAxisTitle').text('Columns');
                        $('#hLegendTitle').text('Rows');

                        // Settings tab -> Chart
                        hideOption($('#ddlSeriesOptions'), Storyboard.Constants.SeriesOptions.Stacked);
                        $('#chkInvertChart').closest('.settingsGroup').hide();
                        showOption($('#ddlColorLogic'), Storyboard.Constants.ColorSources.DYNAMIC_COLORS);
                        $('#ddlColorLogic').val(Storyboard.Constants.ColorSources.DYNAMIC_COLORS);
                        $('#ddlColorLogic').attr('disabled', 'disabled');
                        if ($('#ddlColorLogic').val() == Storyboard.Constants.ColorSources.DYNAMIC_COLORS) {
                            $('#dynamicColorsDiv').show();
                            $('#ddlColorLogic').closest('.settingItem').hide();
                        }
                        $('#ddlColorValueSourceLabel').hide();
                        $('#ddlColorValueSource').hide();

                        hideOption($('#ddlLegendPosition'), Storyboard.Constants.LegendPosition.DataLabel);
                        $('#cbShowValues').attr('checked', 'checked').attr('disabled', 'disabled');
                        $('#ddlBasePosition option').each(function () {
                            if ($(this).val() == Storyboard.Constants.BaseSizePosition.Axis)
                                $(this).text('Columns');
                            else if ($(this).val() == Storyboard.Constants.BaseSizePosition.Legend)
                                $(this).text('Rows');
                            else if ($(this).val() == Storyboard.Constants.BaseSizePosition.Series)
                                $(this).text('Cells');
                        });

                        //Settings tab -> Series
                        $('#thresholdPanel').hide();
                        //Settings -> Series
                        $('#ddlShowTopSeriesMode option').each(function () {
                            if ($(this).val() == 1)
                                $(this).text('Columns');
                            else if ($(this).val() == 2)
                                $(this).text('Rows');
                        });
                        $('#lblTopValuePerGroup').text(locale.get('Values per column group'));

                        // Settings -> Axis and Text
                        $('#chbShowUnitOnYAxis').closest('span').hide();
                        $('#chbShowSeparatorOnYAxis').closest('span').hide();
                        $('.axisScalesWrapper').hide();
                        $('#lblXAxisText').text('Columns text');
                        $('#lblYAxisText').text('Rows text');

                        // Settings -> Tooltip
                        $('#chbShowAxisLabel + label').text('Column label');
                        $('#chbShowLegendLabel + label').text('Row label');

                        // Settings -> Other
                        $('.hdTargetAreas').hide();

                        // Analysis -> Benchmark
                        $('#ddlBenchmarkAxis option').each(function () {
                            if ($(this).val() == Storyboard.Constants.BenchmarkDimension.Legend)
                                $(this).text('Rows');
                            else if ($(this).val() == Storyboard.Constants.BenchmarkDimension.Axis)
                                $(this).text('Columns');
                        });

                        // Analysis -> Statistical Analysis
                        $('#ddlDataCompareType option').each(function () {
                            if ($(this).val() == Storyboard.Constants.ZTestBetween.LegendItems)
                                $(this).text('Row Items');
                            else if ($(this).val() == Storyboard.Constants.ZTestBetween.AxisGroups)
                                $(this).text('Column Groups');
                        });

                        // Analysis -> Mean value series
                        $('#ddlMeanValueOrientation option').each(function () {
                            if ($(this).val() == Storyboard.Constants.MeanValueOrientation.Legend)
                                $(this).text('Row');
                            else if ($(this).val() == Storyboard.Constants.MeanValueOrientation.Axis)
                                $(this).text('Column');
                        });

                        // Layout -> Series
                        $('#chartstyle_series_dataLabels_align').parent().hide();

                        // Layout -> Axes
                        $('#chartstyle_xAxis_lineColor').closest('.settingsFieldsetContent').find('h3').text(locale.get('Column headers'));
                        $('#chartstyle_xAxis_labels_style_width').hide();
                        $('#chartstyle_yAxis_lineColor').closest('.settingsFieldsetContent').find('h3').text(locale.get('Row headers'));
                        $('#chartstyle_yAxis_misc_showLastLabel').closest('.settingItem').hide();
                        $('#chartstyle_xAxis_title_style_color').closest('.settingsFieldsetContent').find('h3').text(locale.get('Column information text'));
                        $('#chartstyle_yAxis_title_style_color').closest('.settingsFieldsetContent').find('h3').text(locale.get('Row information text'));

                        // Layout -> Legend
                        $('#layout').find('.chartStyleLegendSettings').hide();
                    } else if (seriesType == st.MARIMEKKO) {
                        $('#btnCreateDataGroup').hide();
                        $('#btnEditSeries').hide();

                        // Settings -> Chart
                        $('#ddlSeriesOptions').closest('.settingItem').hide();
                        $('#chkInvertChart').closest('.settingItem').hide();
                        $('#chbTransformIntoPolar').closest('.settingItem').hide();
                        $('#chartZooming').closest('.settingItem').hide();

                        // Settings -> Series
                        $('#chkApplyPosNeg').closest('.settingItem').hide();
                        $('#chbShowTopValuesPerGroup').closest('.hdTopValuesPerGroup').hide();
                        $('#thresholdPanel').hide();
                        $('.hdTrimDateGaps').hide();
                        $('.hdTrimEmpty').hide();
                        $('#chbTrimCompareSeries').closest('.settingItem').hide();

                        // Settings -> Other
                        $('.hdTargetAreas').hide();

                        // Analysis -> Mean value series
						$('.hdMeanValueSeries').hide();
						$('.hdAggregatedSeries').hide();
                        $('#percentilePanel').hide();

                        // Layout -> Grid Area
                        $('.chartStyle_GridArea_Background').hide();
                        $('.chartStyle_GridArea_AxisGridlines').hide();
                    }

                    $('#txtGradientMinValue').closest('span').hide();
                    $('#txtGradientMaxValue').closest('span').hide();
                }

                if (dataGroup.optionalChartSettings && Storyboard.ChartLab.openedChartLabArea) {
                    switch (Storyboard.ChartLab.openedChartLabArea) {
                        case Storyboard.ChartLab.parts[0]: // Variables
                            $('#questionBox').parent().css('width', '49%');
                            $('#answerbox').parent().css('width', '49%');

                            var hideQAFiltering = true;
                            var hideQASelection = true;

                            var genSettings = dataGroup.optionalChartSettings.generalSettings;
                            if ((Storyboard.Constants.OptionalChartGeneralSettings.ShowQuestionBlocks & genSettings) != Storyboard.Constants.OptionalChartGeneralSettings.ShowQuestionBlocks ||
								dataGroup.optionalChartSettings.questionBlocks.length <= 0) {
                                $('#qbFilterPanelWrapper').hide();
                            }
                            else {
                                hideShowOptions('#lbQB', dataGroup.optionalChartSettings.questionBlocks);
                                hideQAFiltering = false;
                            }

                            if ((Storyboard.Constants.OptionalChartGeneralSettings.ShowQuestions & genSettings) != Storyboard.Constants.OptionalChartGeneralSettings.ShowQuestions) {
                                $('#questionBox').parent().hide();
                                $('#answerbox').parent().css('width', '100%');
                            } else {
                                $('#questionBox').parent().show();
                                hideQASelection = false;
                            }

                            if ((Storyboard.Constants.OptionalChartGeneralSettings.ShowAnswers & genSettings) != Storyboard.Constants.OptionalChartGeneralSettings.ShowAnswers) {
                                $('#answerbox').parent().wrap('<span class="answerBoxWrapSpan"></span>').parent().hide();
                                $('#questionBox').parent().css('width', '100%');
                            } else {
                                $('.answerBoxWrapSpan > div.settingItemBlock').unwrap();
                                hideQASelection = false;
                            }

                            if ((Storyboard.Constants.OptionalChartGeneralSettings.ShowCalculationTypes & genSettings) != Storyboard.Constants.OptionalChartGeneralSettings.ShowCalculationTypes ||
								dataGroup.optionalChartSettings.calculationTypes.length <= 1)
                                $('#ddlCalculationType').parent().hide();
                            else if (dataGroup.optionalChartSettings.calculationTypes) {
                                $('#ddlCalculationType').parent().show();
                                hideShowOptions('#ddlCalculationType', dataGroup.optionalChartSettings.calculationTypes);
                                hideQAFiltering = false;
                            }

                            // make fieldsets fill popup
                            if (hideQAFiltering) {
                                $('#sbTextQAFiltering').closest('fieldset').hide();
                                $('#sbTextQASelection').closest('fieldset').css('width', '100%');
                            } else {
                                $('#sbTextQAFiltering').closest('fieldset').show();
                                $('#sbTextQASelection').closest('fieldset').css('width', '74.5%');
                            }

                            if (hideQASelection) {
                                $('#sbTextQASelection').closest('fieldset').hide();
                                $('#sbTextQAFiltering').closest('fieldset').css('width', '100%');
                            } else {
                                $('#sbTextQASelection').closest('fieldset').show();
                                $('#sbTextQAFiltering').closest('fieldset').css('width', '23.5%');
                            }

                            break;

                        case Storyboard.ChartLab.parts[1]: // Filters
                            ChartSetupUI.hideHFilterPanel(false);

                            if (dataGroup.optionalChartSettings.filters.length > 0) {
                                $('#filterSelection .settingItemBlock').not('.filterboxTemplate').hide();
                                for (var i = 0; i < dataGroup.optionalChartSettings.filters.length; i++) {
                                    var filterBlock = $('input[id="hidFilterId"][value="' + dataGroup.optionalChartSettings.filters[i].filterId + '"]').closest('.settingItemBlock');
                                    filterBlock.show();
                                    if (!dataGroup.optionalChartSettings.filters[i].compare) {
                                        filterBlock.find('[id="chkCompare"]').hide();
                                        filterBlock.find('label[for="chkCompare"]').hide();
                                    }
                                    else {
                                        filterBlock.find('[id="chkCompare"]').show();
                                        filterBlock.find('label[for="chkCompare"]').show();
                                    }
                                }
                            }

                            break;

                        case Storyboard.ChartLab.parts[2]:
                            $('.timePeriodSelections').css('display', dataGroup.optionalChartSettings.timePeriods.length <= 1 ? 'none' : 'block');
                            $('#ddlTimePeriod').closest('table.settingsTable').css('display', dataGroup.optionalChartSettings.timePeriods.length <= 1 ? 'none' : 'block');
                            $('.hdIntervals, .hdMovAvg').css('text-align', dataGroup.optionalChartSettings.timePeriods.length <= 1 ? 'left' : '');
                            if (dataGroup.optionalChartSettings.timePeriods.length > 1)
                                hideShowOptions('#ddlTimePeriod', dataGroup.optionalChartSettings.timePeriods);

                            $('.hdMovAvg').css('display', dataGroup.optionalChartSettings.movingAverages.length <= 1 ? 'none' : 'block');
                            if (dataGroup.optionalChartSettings.movingAverages.length > 1)
                                hideShowOptions('#ddlMovingAverage', dataGroup.optionalChartSettings.movingAverages);

							$('.hdIntervals').css('display', dataGroup.optionalChartSettings.timeIntervals.length <= 1 ? 'none' : 'block');
                            if (dataGroup.optionalChartSettings.timeIntervals.length > 1)
                                hideShowOptions('#ddlInterval', dataGroup.optionalChartSettings.timeIntervals);
                            break;

                        case Storyboard.ChartLab.parts[3]:
                            $('.SeriesTypeWrapper').css('display', dataGroup.optionalChartSettings.seriesTypes.length <= 1 ? 'none' : 'block');
                            if (dataGroup.optionalChartSettings.seriesTypes.length > 0)
                                hideShowOptions('#ddlSeriesType', dataGroup.optionalChartSettings.seriesTypes);

                            $('.SeriesOptionWrapper').css('display', dataGroup.optionalChartSettings.seriesAttributes.length <= 1 ? 'none' : 'block');
                            if (dataGroup.optionalChartSettings.seriesAttributes.length > 0)
                                hideShowOptions('#ddlSeriesOptions', dataGroup.optionalChartSettings.seriesAttributes);
                            break;

                        default:
                            break;
                    }
                }

                if (($('#chkPercentile').attr('checked')) &&
                    (seriesType == st.COLUMN || seriesType == st.LINE || seriesType == st.SPLINE || seriesType == st.AREA ||
                    seriesType == st.VERTICALLINE || seriesType == st.VERTICALSPLINE || seriesType == 12)) { // 12 = Vertical area
                    $("#ddlSeriesOptions option[value='2']").attr('disabled', 'disabled');
                    if ($("#ddlSeriesOptions option[value='2']").attr('disabled'))
                        $("#ddlSeriesOptions option[value='1']").attr('selected', 'selected');
                }
                else
                    $("#ddlSeriesOptions option[value='2']").removeAttr('disabled');
            }
        },
        HideOption: hideOption,
        ShowOption: showOption
    };
}();